{
  "v": "5.7.4",
  "fr": 29.9700012207031,
  "ip": 0,
  "op": 90.0000036657751,
  "w": 1080,
  "h": 1080,
  "nm": "Comp 1",
  "ddd": 0,
  "assets": [
    {
      "id": "comp_0",
      "layers": [
        {
          "ddd": 0,
          "ind": 1,
          "ty": 4,
          "nm": "Layer 2 Outlines",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [
                955.924,
                543.18,
                0
              ],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [
                184.913,
                136.372,
                0
              ],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [
                400,
                400,
                100
              ],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          -3.283,
                          2.215
                        ],
                        [
                          -5.859,
                          1.288
                        ],
                        [
                          0.572,
                          0.726
                        ],
                        [
                          3.424,
                          -5.778
                        ],
                        [
                          -1.507,
                          -1.003
                        ],
                        [
                          -1.643,
                          0.287
                        ],
                        [
                          -2.497,
                          0.138
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          -57.201,
                          80.773
                        ],
                        [
                          -49.137,
                          77.846
                        ],
                        [
                          -65.698,
                          62.711
                        ],
                        [
                          -74.049,
                          78.985
                        ],
                        [
                          -74.828,
                          83.488
                        ],
                        [
                          -72.333,
                          84.413
                        ],
                        [
                          -68.7,
                          83.773
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0.109,
                          1.238
                        ],
                        [
                          2.432,
                          -1.139
                        ],
                        [
                          -0.486,
                          0.212
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.781,
                          1.082
                        ]
                      ],
                      "v": [
                        [
                          -155.02,
                          -18.161
                        ],
                        [
                          -153.777,
                          -17.892
                        ],
                        [
                          -150.76,
                          -21.724
                        ],
                        [
                          -152.539,
                          -22.152
                        ],
                        [
                          -153.832,
                          -21.724
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 2,
                  "ty": "sh",
                  "ix": 3,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          2.39,
                          0.982
                        ],
                        [
                          -0.329,
                          3.043
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          -1.191
                        ],
                        [
                          2.707,
                          1.737
                        ],
                        [
                          0.763,
                          -0.11
                        ],
                        [
                          1.951,
                          1.852
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.852,
                          1.408
                        ],
                        [
                          0.546,
                          4.664
                        ],
                        [
                          1.951,
                          1.081
                        ],
                        [
                          -3.143,
                          3.908
                        ],
                        [
                          -1.296,
                          2.061
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.377,
                          3.91
                        ],
                        [
                          -2.061,
                          -0.982
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.536,
                          0.658
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -3.04,
                          2.388
                        ],
                        [
                          -0.545,
                          0.87
                        ],
                        [
                          -1.194,
                          0.112
                        ],
                        [
                          -0.864,
                          2.277
                        ],
                        [
                          -2.179,
                          3.148
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.758,
                          -1.737
                        ],
                        [
                          3.79,
                          -8.017
                        ],
                        [
                          -2.312,
                          3.681
                        ],
                        [
                          -0.429,
                          -1.518
                        ],
                        [
                          2.707,
                          -2.494
                        ],
                        [
                          -4.043,
                          -2.346
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.482,
                          -3.522
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -4.83,
                          -1.173
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -4.696,
                          -2.607
                        ],
                        [
                          -4.571,
                          -5.873
                        ],
                        [
                          -3.918,
                          -0.919
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -3.395,
                          0.264
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.546,
                          0.588
                        ],
                        [
                          -0.689,
                          1.369
                        ],
                        [
                          0.629,
                          0
                        ],
                        [
                          -0.446,
                          1.959
                        ],
                        [
                          -1.765,
                          -0.638
                        ],
                        [
                          -0.442,
                          -1.222
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.729,
                          0.392
                        ],
                        [
                          -1.071,
                          1.123
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.734,
                          0.533
                        ],
                        [
                          -0.298,
                          0.836
                        ],
                        [
                          -1.032,
                          -0.044
                        ],
                        [
                          -0.298,
                          0.59
                        ],
                        [
                          -0.397,
                          1.37
                        ],
                        [
                          -0.685,
                          0.828
                        ],
                        [
                          0.055,
                          1.082
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.738,
                          2.98
                        ],
                        [
                          1.568,
                          2.351
                        ],
                        [
                          1.071,
                          3.908
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.27,
                          -0.436
                        ],
                        [
                          0.927,
                          -0.497
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.59,
                          0.541
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.244,
                          1.612
                        ],
                        [
                          0.541,
                          -0.149
                        ],
                        [
                          0,
                          0.839
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.392,
                          0.436
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.53,
                          -0.248
                        ],
                        [
                          0.485,
                          0.778
                        ],
                        [
                          -0.784,
                          2.008
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.206,
                          1.324
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.243,
                          1.125
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.099,
                          1.034
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -9.445,
                          5.916
                        ],
                        [
                          -7.39,
                          0
                        ],
                        [
                          -2.594,
                          1.131
                        ],
                        [
                          -1.022,
                          -1.266
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.193,
                          -0.881
                        ],
                        [
                          0.392,
                          -0.727
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.517,
                          -0.588
                        ],
                        [
                          -1.27,
                          -9.537
                        ],
                        [
                          -3.432,
                          -0.387
                        ],
                        [
                          -1.325,
                          0.104
                        ],
                        [
                          -1.568,
                          -0.154
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.15,
                          -0.535
                        ],
                        [
                          -3.814,
                          -2.155
                        ],
                        [
                          -1.126,
                          0.099
                        ],
                        [
                          -1.956,
                          -0.676
                        ],
                        [
                          -1.609,
                          -0.209
                        ],
                        [
                          -1.859,
                          -0.928
                        ],
                        [
                          -0.045,
                          -1.666
                        ],
                        [
                          -0.596,
                          -0.783
                        ],
                        [
                          0.828,
                          -0.541
                        ],
                        [
                          0.972,
                          0.094
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.485,
                          -1.225
                        ],
                        [
                          1.022,
                          -5.387
                        ],
                        [
                          3.715,
                          -3.223
                        ],
                        [
                          0.873,
                          -1.233
                        ],
                        [
                          11.99,
                          -10.329
                        ],
                        [
                          1.317,
                          -0.888
                        ],
                        [
                          0.049,
                          -0.648
                        ],
                        [
                          -0.439,
                          -0.29
                        ],
                        [
                          0.391,
                          -1.28
                        ],
                        [
                          0.436,
                          -0.392
                        ],
                        [
                          0.831,
                          -0.831
                        ],
                        [
                          0.193,
                          -0.585
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -5.436,
                          2.798
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.004,
                          -0.977
                        ],
                        [
                          0.541,
                          -2.693
                        ],
                        [
                          2.787,
                          -2.649
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -3.004,
                          0.846
                        ],
                        [
                          -1.964,
                          1.105
                        ],
                        [
                          -17.162,
                          -5.747
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.089,
                          -0.389
                        ],
                        [
                          -4.114,
                          -3.13
                        ],
                        [
                          -5.089,
                          -5.287
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -9.007,
                          -3.719
                        ],
                        [
                          -3.13,
                          -3.526
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -4.89,
                          -3.521
                        ],
                        [
                          -6.462,
                          2.544
                        ],
                        [
                          -6.653,
                          -2.351
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -5.282,
                          -0.193
                        ],
                        [
                          -3.521,
                          -1.765
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.886,
                          -1.324
                        ],
                        [
                          8.03,
                          -2.345
                        ],
                        [
                          -5.48,
                          3.508
                        ],
                        [
                          13.844,
                          -0.186
                        ],
                        [
                          -2.351,
                          0.196
                        ],
                        [
                          13.314,
                          2.351
                        ],
                        [
                          17.81,
                          11.358
                        ],
                        [
                          6.269,
                          1.959
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          3.328,
                          6.656
                        ],
                        [
                          6.269,
                          5.292
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          5.293,
                          -5.873
                        ],
                        [
                          2.351,
                          -1.959
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -13.51,
                          -2.346
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.176,
                          -5.287
                        ],
                        [
                          5.679,
                          -4.89
                        ],
                        [
                          2.737,
                          -4.504
                        ],
                        [
                          0.59,
                          -1.76
                        ],
                        [
                          1.125,
                          -1.643
                        ],
                        [
                          -0.298,
                          -1.275
                        ],
                        [
                          0.747,
                          -0.828
                        ],
                        [
                          -1.427,
                          -0.603
                        ],
                        [
                          -0.295,
                          -1.05
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          3.069,
                          0.671
                        ],
                        [
                          0.825,
                          7.199
                        ],
                        [
                          0.977,
                          1.415
                        ],
                        [
                          -0.373,
                          4.79
                        ],
                        [
                          -2.918,
                          2.319
                        ],
                        [
                          -1.416,
                          0.833
                        ],
                        [
                          -3.296,
                          4.796
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          2.918,
                          1.202
                        ],
                        [
                          3.594,
                          -0.306
                        ],
                        [
                          1.497,
                          -0.523
                        ],
                        [
                          6.367,
                          -2.539
                        ],
                        [
                          4.645,
                          -2.774
                        ],
                        [
                          1.568,
                          -1.202
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.575,
                          -0.371
                        ],
                        [
                          0.522,
                          -0.969
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.295,
                          -0.966
                        ],
                        [
                          1.201,
                          -2.463
                        ],
                        [
                          3.968,
                          1.048
                        ],
                        [
                          0.888,
                          7.871
                        ],
                        [
                          -0.828,
                          2.471
                        ],
                        [
                          -1.645,
                          3.066
                        ],
                        [
                          -0.446,
                          2.181
                        ],
                        [
                          -0.676,
                          1.499
                        ],
                        [
                          -0.821,
                          0.899
                        ],
                        [
                          -5.164,
                          2.325
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.833,
                          -0.219
                        ],
                        [
                          -1.427,
                          1.345
                        ],
                        [
                          2.766,
                          3.369
                        ],
                        [
                          4.948,
                          4.035
                        ],
                        [
                          2.171,
                          2.325
                        ],
                        [
                          0.524,
                          1.052
                        ],
                        [
                          17.221,
                          -6.891
                        ],
                        [
                          4.122,
                          -1.797
                        ],
                        [
                          10.552,
                          0.522
                        ],
                        [
                          1.27,
                          1.048
                        ],
                        [
                          0.898,
                          0.144
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -3.516,
                          -4.485
                        ],
                        [
                          -1.8,
                          -4.044
                        ],
                        [
                          -2.327,
                          -1.055
                        ],
                        [
                          -0.449,
                          -0.603
                        ],
                        [
                          3.14,
                          -1.643
                        ],
                        [
                          1.573,
                          -0.447
                        ],
                        [
                          -0.828,
                          -3.297
                        ],
                        [
                          -1.423,
                          -1.649
                        ],
                        [
                          -2.171,
                          -2.998
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.901,
                          -2.395
                        ],
                        [
                          1.575,
                          -2.923
                        ],
                        [
                          -0.23,
                          -1.572
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.818,
                          -0.651
                        ],
                        [
                          5.744,
                          3.258
                        ],
                        [
                          -5.094,
                          3.916
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.049,
                          3.657
                        ],
                        [
                          1.961,
                          2.604
                        ],
                        [
                          8.62,
                          8.615
                        ],
                        [
                          1.703,
                          2.879
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          4.041,
                          0.125
                        ],
                        [
                          4.968,
                          -1.04
                        ],
                        [
                          2.612,
                          -1.311
                        ],
                        [
                          3.521,
                          2.215
                        ],
                        [
                          0.397,
                          1.432
                        ],
                        [
                          -0.523,
                          3.521
                        ],
                        [
                          -0.909,
                          15.788
                        ],
                        [
                          -0.392,
                          2.089
                        ],
                        [
                          2.748,
                          3.386
                        ],
                        [
                          0.262,
                          4.566
                        ],
                        [
                          1.568,
                          8.223
                        ],
                        [
                          3.526,
                          4.835
                        ],
                        [
                          0.653,
                          2.09
                        ],
                        [
                          0,
                          1.567
                        ],
                        [
                          4.436,
                          12.141
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.957,
                          -0.131
                        ],
                        [
                          1.437,
                          0
                        ],
                        [
                          -0.006,
                          1.319
                        ],
                        [
                          2.613,
                          0.442
                        ],
                        [
                          1.413,
                          -1.298
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          3.476,
                          -0.215
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.201,
                          -0.081
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.389,
                          -0.063
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.324,
                          0.361
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          -151.786,
                          -17.378
                        ],
                        [
                          -156.235,
                          -16.082
                        ],
                        [
                          -157.646,
                          -19.548
                        ],
                        [
                          -159.271,
                          -18.354
                        ],
                        [
                          -160.683,
                          -17.163
                        ],
                        [
                          -164.153,
                          -12.712
                        ],
                        [
                          -166.112,
                          -12.388
                        ],
                        [
                          -170.448,
                          -13.911
                        ],
                        [
                          -171.537,
                          -14.339
                        ],
                        [
                          -175.118,
                          -15.207
                        ],
                        [
                          -178.697,
                          -19.657
                        ],
                        [
                          -180.102,
                          -22.583
                        ],
                        [
                          -181.52,
                          -28.879
                        ],
                        [
                          -175.225,
                          -34.85
                        ],
                        [
                          -170.448,
                          -41.145
                        ],
                        [
                          -170.889,
                          -46.892
                        ],
                        [
                          -165.129,
                          -50.8
                        ],
                        [
                          -163.293,
                          -48.953
                        ],
                        [
                          -162.852,
                          -49.818
                        ],
                        [
                          -162.206,
                          -51.782
                        ],
                        [
                          -157.758,
                          -57.529
                        ],
                        [
                          -152.218,
                          -64.365
                        ],
                        [
                          -149.175,
                          -67.183
                        ],
                        [
                          -146.575,
                          -69.573
                        ],
                        [
                          -140.393,
                          -73.909
                        ],
                        [
                          -135.395,
                          -84.985
                        ],
                        [
                          -134.097,
                          -86.933
                        ],
                        [
                          -131.926,
                          -87.474
                        ],
                        [
                          -132.349,
                          -76.098
                        ],
                        [
                          -126.608,
                          -81.396
                        ],
                        [
                          -124.33,
                          -82.704
                        ],
                        [
                          -126.496,
                          -73.262
                        ],
                        [
                          -116.51,
                          -72.446
                        ],
                        [
                          -119.247,
                          -71.663
                        ],
                        [
                          -110.632,
                          -67.488
                        ],
                        [
                          -111.421,
                          -66.966
                        ],
                        [
                          -104.896,
                          -64.09
                        ],
                        [
                          -106.2,
                          -63.307
                        ],
                        [
                          -100.064,
                          -60.833
                        ],
                        [
                          -89.62,
                          -51.562
                        ],
                        [
                          -80.875,
                          -45.685
                        ],
                        [
                          -84.009,
                          -45.56
                        ],
                        [
                          -75.395,
                          -43.995
                        ],
                        [
                          -72.26,
                          -44.516
                        ],
                        [
                          -71.85,
                          -45.724
                        ],
                        [
                          -72.396,
                          -48.415
                        ],
                        [
                          -73.025,
                          -48.909
                        ],
                        [
                          -74.444,
                          -51.061
                        ],
                        [
                          -72.049,
                          -52.134
                        ],
                        [
                          -70.828,
                          -50.766
                        ],
                        [
                          -68.478,
                          -54.138
                        ],
                        [
                          -67.451,
                          -55.264
                        ],
                        [
                          -66.474,
                          -56.881
                        ],
                        [
                          -64.609,
                          -58.79
                        ],
                        [
                          -63.389,
                          -60.402
                        ],
                        [
                          -61.43,
                          -63.346
                        ],
                        [
                          -60.255,
                          -65.446
                        ],
                        [
                          -58.93,
                          -66.621
                        ],
                        [
                          -57.418,
                          -70.535
                        ],
                        [
                          -56.143,
                          -73.324
                        ],
                        [
                          -55.464,
                          -75.73
                        ],
                        [
                          -56.098,
                          -78.71
                        ],
                        [
                          -58.057,
                          -84.042
                        ],
                        [
                          -60.498,
                          -90.217
                        ],
                        [
                          -65.392,
                          -97.651
                        ],
                        [
                          -65.834,
                          -98.589
                        ],
                        [
                          -68.572,
                          -100.052
                        ],
                        [
                          -69.653,
                          -99.163
                        ],
                        [
                          -71.022,
                          -98.589
                        ],
                        [
                          -72.639,
                          -98.534
                        ],
                        [
                          -73.665,
                          -98.247
                        ],
                        [
                          -75.774,
                          -99.318
                        ],
                        [
                          -76.552,
                          -99.947
                        ],
                        [
                          -78.218,
                          -100.543
                        ],
                        [
                          -78.268,
                          -101.326
                        ],
                        [
                          -78.754,
                          -101.376
                        ],
                        [
                          -79.741,
                          -101.663
                        ],
                        [
                          -80.707,
                          -102.69
                        ],
                        [
                          -81.491,
                          -102.69
                        ],
                        [
                          -83.014,
                          -102.641
                        ],
                        [
                          -83.113,
                          -105.874
                        ],
                        [
                          -82.92,
                          -107.143
                        ],
                        [
                          -84.832,
                          -109.941
                        ],
                        [
                          -85.122,
                          -110.913
                        ],
                        [
                          -86.734,
                          -112.43
                        ],
                        [
                          -88.257,
                          -112.292
                        ],
                        [
                          -89.427,
                          -113.123
                        ],
                        [
                          -88.494,
                          -115.035
                        ],
                        [
                          -87.275,
                          -116.25
                        ],
                        [
                          -78.958,
                          -129.66
                        ],
                        [
                          -69.608,
                          -131.376
                        ],
                        [
                          -68.041,
                          -135.096
                        ],
                        [
                          -65.199,
                          -134.857
                        ],
                        [
                          -65.001,
                          -134.313
                        ],
                        [
                          -63.538,
                          -132.698
                        ],
                        [
                          -63.191,
                          -131.329
                        ],
                        [
                          -62.903,
                          -130.642
                        ],
                        [
                          -63.433,
                          -128.391
                        ],
                        [
                          -58.201,
                          -116.206
                        ],
                        [
                          -52.032,
                          -115.863
                        ],
                        [
                          -46.642,
                          -114.93
                        ],
                        [
                          -40.872,
                          -114.881
                        ],
                        [
                          -39.702,
                          -115.129
                        ],
                        [
                          -35.099,
                          -115.129
                        ],
                        [
                          -27.66,
                          -112.535
                        ],
                        [
                          -23.303,
                          -111.161
                        ],
                        [
                          -16.697,
                          -110.188
                        ],
                        [
                          -11.313,
                          -108.954
                        ],
                        [
                          -6.024,
                          -106.857
                        ],
                        [
                          -5.047,
                          -104.798
                        ],
                        [
                          -3.182,
                          -100.096
                        ],
                        [
                          -2.398,
                          -97.993
                        ],
                        [
                          -4.357,
                          -97.552
                        ],
                        [
                          -2.604,
                          -94.913
                        ],
                        [
                          -0.643,
                          -91.779
                        ],
                        [
                          2.348,
                          -80.669
                        ],
                        [
                          -1.521,
                          -70.443
                        ],
                        [
                          -5.092,
                          -66.274
                        ],
                        [
                          -22.423,
                          -48.657
                        ],
                        [
                          -27.459,
                          -44.298
                        ],
                        [
                          -28.344,
                          -43.514
                        ],
                        [
                          -28.099,
                          -42.595
                        ],
                        [
                          -27.66,
                          -40.578
                        ],
                        [
                          -28.386,
                          -39.358
                        ],
                        [
                          -29.175,
                          -37.893
                        ],
                        [
                          -28.977,
                          -36.274
                        ],
                        [
                          -27.806,
                          -31.727
                        ],
                        [
                          -19.628,
                          -33.834
                        ],
                        [
                          -7.155,
                          -40.876
                        ],
                        [
                          -1.327,
                          -42.344
                        ],
                        [
                          -0.494,
                          -38.967
                        ],
                        [
                          -2.304,
                          -32.162
                        ],
                        [
                          -1.763,
                          -30.744
                        ],
                        [
                          9.445,
                          -33.094
                        ],
                        [
                          12.966,
                          -34.333
                        ],
                        [
                          47.682,
                          -36.878
                        ],
                        [
                          60.539,
                          -32.51
                        ],
                        [
                          66.805,
                          -30.292
                        ],
                        [
                          75.028,
                          -25.853
                        ],
                        [
                          97.932,
                          -14.298
                        ],
                        [
                          94.609,
                          -15.28
                        ],
                        [
                          107.137,
                          -6.076
                        ],
                        [
                          122.016,
                          1.557
                        ],
                        [
                          119.863,
                          1.365
                        ],
                        [
                          127.888,
                          8.407
                        ],
                        [
                          142.573,
                          11.74
                        ],
                        [
                          160.581,
                          12.325
                        ],
                        [
                          158.431,
                          12.916
                        ],
                        [
                          167.825,
                          15.068
                        ],
                        [
                          184.663,
                          19.378
                        ],
                        [
                          179.966,
                          18.788
                        ],
                        [
                          184.642,
                          20.935
                        ],
                        [
                          177.03,
                          21.332
                        ],
                        [
                          166.456,
                          27.204
                        ],
                        [
                          179.561,
                          23.111
                        ],
                        [
                          159.999,
                          29.357
                        ],
                        [
                          169,
                          30.535
                        ],
                        [
                          144.919,
                          32.687
                        ],
                        [
                          118.494,
                          21.917
                        ],
                        [
                          106.74,
                          17.22
                        ],
                        [
                          107.915,
                          18.981
                        ],
                        [
                          100.873,
                          12.721
                        ],
                        [
                          90.294,
                          0.184
                        ],
                        [
                          87.165,
                          -0.009
                        ],
                        [
                          79.526,
                          17.613
                        ],
                        [
                          73.461,
                          24.66
                        ],
                        [
                          71.502,
                          27.204
                        ],
                        [
                          85.404,
                          33.859
                        ],
                        [
                          94.217,
                          35.038
                        ],
                        [
                          98.13,
                          41.109
                        ],
                        [
                          92.65,
                          48.151
                        ],
                        [
                          75.227,
                          70.276
                        ],
                        [
                          72.286,
                          74.779
                        ],
                        [
                          71.202,
                          78.35
                        ],
                        [
                          70.604,
                          80.975
                        ],
                        [
                          69.778,
                          84.123
                        ],
                        [
                          72.179,
                          86.437
                        ],
                        [
                          74.046,
                          87.717
                        ],
                        [
                          74.647,
                          88.164
                        ],
                        [
                          78.915,
                          101.721
                        ],
                        [
                          75.17,
                          102.69
                        ],
                        [
                          63.266,
                          92.73
                        ],
                        [
                          61.615,
                          85.996
                        ],
                        [
                          58.47,
                          77.977
                        ],
                        [
                          62.065,
                          72.439
                        ],
                        [
                          64.533,
                          70.411
                        ],
                        [
                          74.276,
                          57.087
                        ],
                        [
                          77.497,
                          52.294
                        ],
                        [
                          76.669,
                          48.548
                        ],
                        [
                          69.026,
                          46.981
                        ],
                        [
                          63.645,
                          47.72
                        ],
                        [
                          61.092,
                          56.789
                        ],
                        [
                          31.361,
                          72.595
                        ],
                        [
                          25.301,
                          76.639
                        ],
                        [
                          22.973,
                          78.954
                        ],
                        [
                          22.073,
                          80.458
                        ],
                        [
                          20.348,
                          82.404
                        ],
                        [
                          18.559,
                          83.598
                        ],
                        [
                          17.955,
                          86.448
                        ],
                        [
                          19.006,
                          88.469
                        ],
                        [
                          20.053,
                          90.039
                        ],
                        [
                          19.677,
                          97.003
                        ],
                        [
                          12.867,
                          104.492
                        ],
                        [
                          7.779,
                          95.877
                        ],
                        [
                          8.147,
                          90.64
                        ],
                        [
                          9.27,
                          84.57
                        ],
                        [
                          10.994,
                          78.954
                        ],
                        [
                          10.845,
                          76.036
                        ],
                        [
                          11.666,
                          73.713
                        ],
                        [
                          19.23,
                          68.173
                        ],
                        [
                          22.827,
                          66.151
                        ],
                        [
                          25.301,
                          65.398
                        ],
                        [
                          39.53,
                          56.497
                        ],
                        [
                          40.052,
                          50.651
                        ],
                        [
                          32.709,
                          42.794
                        ],
                        [
                          19.455,
                          34.03
                        ],
                        [
                          11.815,
                          27.51
                        ],
                        [
                          -11.851,
                          41.443
                        ],
                        [
                          -20.02,
                          45.189
                        ],
                        [
                          -39.336,
                          49.306
                        ],
                        [
                          -43.08,
                          49.454
                        ],
                        [
                          -45.258,
                          49.684
                        ],
                        [
                          -47.204,
                          50.881
                        ],
                        [
                          -43.832,
                          58.735
                        ],
                        [
                          -36.416,
                          69.597
                        ],
                        [
                          -32.373,
                          70.2
                        ],
                        [
                          -25.861,
                          73.118
                        ],
                        [
                          -25.555,
                          76.111
                        ],
                        [
                          -30.202,
                          79.032
                        ],
                        [
                          -27.503,
                          85.1
                        ],
                        [
                          -23.834,
                          91.393
                        ],
                        [
                          -17.543,
                          97.826
                        ],
                        [
                          -12.525,
                          103.062
                        ],
                        [
                          -7.959,
                          108.008
                        ],
                        [
                          -7.058,
                          114.079
                        ],
                        [
                          -7.581,
                          117.523
                        ],
                        [
                          -7.356,
                          121.941
                        ],
                        [
                          -7.437,
                          124.418
                        ],
                        [
                          -8.046,
                          125.941
                        ],
                        [
                          -8.432,
                          130.643
                        ],
                        [
                          -21.885,
                          132.865
                        ],
                        [
                          -19.398,
                          125.682
                        ],
                        [
                          -15.621,
                          123.986
                        ],
                        [
                          -14.967,
                          118.501
                        ],
                        [
                          -19.928,
                          109.764
                        ],
                        [
                          -32.2,
                          94.882
                        ],
                        [
                          -42.769,
                          85.217
                        ],
                        [
                          -44.2,
                          86.784
                        ],
                        [
                          -51.898,
                          89.794
                        ],
                        [
                          -68.613,
                          92.009
                        ],
                        [
                          -73.179,
                          93.32
                        ],
                        [
                          -79.965,
                          92.923
                        ],
                        [
                          -85.059,
                          88.618
                        ],
                        [
                          -86.099,
                          83.53
                        ],
                        [
                          -83.492,
                          60.031
                        ],
                        [
                          -83.492,
                          50.502
                        ],
                        [
                          -92.368,
                          44.765
                        ],
                        [
                          -98.105,
                          37.713
                        ],
                        [
                          -102.676,
                          28.706
                        ],
                        [
                          -106.719,
                          14.478
                        ],
                        [
                          -115.726,
                          0.905
                        ],
                        [
                          -117.165,
                          -1.832
                        ],
                        [
                          -126.951,
                          -22.98
                        ],
                        [
                          -128.779,
                          -26.768
                        ],
                        [
                          -132.559,
                          -28.46
                        ],
                        [
                          -133.873,
                          -27.024
                        ],
                        [
                          -135.186,
                          -27.794
                        ],
                        [
                          -140.393,
                          -27.473
                        ],
                        [
                          -143.211,
                          -26.384
                        ],
                        [
                          -144.515,
                          -25.736
                        ],
                        [
                          -148.098,
                          -22.152
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 3",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 3,
                  "ty": "sh",
                  "ix": 4,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          -1.614,
                          -0.734
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          2.421,
                          1.095
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.102,
                          -3.009
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          1.542
                        ],
                        [
                          1.761,
                          0.298
                        ],
                        [
                          -0.808,
                          -0.441
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          -64.165,
                          -37.561
                        ],
                        [
                          -66.145,
                          -37.337
                        ],
                        [
                          -62.401,
                          -36.313
                        ],
                        [
                          -57.044,
                          -32.648
                        ],
                        [
                          -56.018,
                          -39.1
                        ],
                        [
                          -62.033,
                          -43.802
                        ],
                        [
                          -63.726,
                          -42.624
                        ],
                        [
                          -65.406,
                          -39.398
                        ],
                        [
                          -61.965,
                          -38.003
                        ],
                        [
                          -64.235,
                          -38.295
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 4",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 4,
                  "ty": "sh",
                  "ix": 5,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          1.567,
                          -0.648
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.641,
                          0.266
                        ]
                      ],
                      "v": [
                        [
                          -146.392,
                          -23.236
                        ],
                        [
                          -145.462,
                          -25.016
                        ],
                        [
                          -147.894,
                          -23.665
                        ],
                        [
                          -147.95,
                          -22.962
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 5",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 5,
                  "ty": "sh",
                  "ix": 6,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          -0.954,
                          2.936
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          -54.996,
                          -39.029
                        ],
                        [
                          -55.359,
                          -32.35
                        ],
                        [
                          -53.45,
                          -32.35
                        ],
                        [
                          -53.897,
                          -37.779
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 6",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 6,
                  "ty": "sh",
                  "ix": 7,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.784,
                          -0.784
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0.293,
                          0.212
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          -55.73,
                          -44.747
                        ],
                        [
                          -61.362,
                          -45.915
                        ],
                        [
                          -55.581,
                          -41.597
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 7",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 7,
                  "ty": "sh",
                  "ix": 8,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          1.104,
                          0.591
                        ],
                        [
                          1.316,
                          -2.208
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          -55.869,
                          -45.779
                        ],
                        [
                          -56.9,
                          -48.423
                        ],
                        [
                          -60.053,
                          -46.873
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 8",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "mm",
                  "mm": 1,
                  "nm": "Merge Paths 1",
                  "mn": "ADBE Vector Filter - Merge",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [
                      0.952941176471,
                      0.325490196078,
                      1,
                      1
                    ],
                    "ix": 4
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 5
                  },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": {
                    "a": 0,
                    "k": [
                      184.913,
                      136.372
                    ],
                    "ix": 2
                  },
                  "a": {
                    "a": 0,
                    "k": [
                      0,
                      0
                    ],
                    "ix": 1
                  },
                  "s": {
                    "a": 0,
                    "k": [
                      100,
                      100
                    ],
                    "ix": 3
                  },
                  "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 6
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 7
                  },
                  "sk": {
                    "a": 0,
                    "k": 0,
                    "ix": 4
                  },
                  "sa": {
                    "a": 0,
                    "k": 0,
                    "ix": 5
                  },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 10,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 61.0000024845809,
          "op": 90.0000036657751,
          "st": 61.0000024845809,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 3,
          "ty": 4,
          "nm": "Layer 3 Outlines",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [
                955.952,
                539.601,
                0
              ],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [
                186.091,
                123.961,
                0
              ],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [
                400,
                400,
                100
              ],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0.115,
                          0.488
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.308,
                          -0.074
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          -131.518,
                          -28.112
                        ],
                        [
                          -131.421,
                          -29.287
                        ],
                        [
                          -132.106,
                          -29.429
                        ],
                        [
                          -134.313,
                          -27.694
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0.52,
                          -1.628
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0.883
                        ],
                        [
                          0.222,
                          0.886
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.808,
                          -1.996
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          -60.938,
                          -63.3
                        ],
                        [
                          -59.904,
                          -66.913
                        ],
                        [
                          -60.269,
                          -68.909
                        ],
                        [
                          -61.23,
                          -70.753
                        ],
                        [
                          -61.967,
                          -72.226
                        ],
                        [
                          -61.528,
                          -67.723
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 2,
                  "ty": "sh",
                  "ix": 3,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          -1.841,
                          -1.69
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.455,
                          6.437
                        ],
                        [
                          1.99,
                          4.289
                        ],
                        [
                          3.829,
                          -2.302
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          -1.222
                        ],
                        [
                          -3.064,
                          -2.142
                        ],
                        [
                          -7.655,
                          -4.284
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          -60.99,
                          97.179
                        ],
                        [
                          -57.623,
                          98.71
                        ],
                        [
                          -59.457,
                          88.598
                        ],
                        [
                          -65.282,
                          62.404
                        ],
                        [
                          -77.079,
                          73.127
                        ],
                        [
                          -80.143,
                          76.653
                        ],
                        [
                          -81.676,
                          79.56
                        ],
                        [
                          -79.22,
                          85.226
                        ],
                        [
                          -67.124,
                          94.418
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 3",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 3,
                  "ty": "sh",
                  "ix": 4,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          -0.144,
                          -1.105
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.286,
                          1.324
                        ],
                        [
                          -3.027,
                          3.618
                        ],
                        [
                          -0.222,
                          1.484
                        ],
                        [
                          -0.293,
                          2.358
                        ],
                        [
                          -0.962,
                          2.139
                        ],
                        [
                          -0.734,
                          4.284
                        ],
                        [
                          -1.251,
                          3.391
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.179,
                          1.027
                        ],
                        [
                          -0.292,
                          0.512
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0.812
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.178,
                          -0.959
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.324,
                          -2.876
                        ],
                        [
                          0.296,
                          -0.663
                        ],
                        [
                          3.1,
                          -5.533
                        ],
                        [
                          5.161,
                          -6.193
                        ]
                      ],
                      "v": [
                        [
                          -32.609,
                          -76.946
                        ],
                        [
                          -33.056,
                          -78.571
                        ],
                        [
                          -32.983,
                          -81.295
                        ],
                        [
                          -34.678,
                          -80.783
                        ],
                        [
                          -36.89,
                          -79.746
                        ],
                        [
                          -39.542,
                          -77.095
                        ],
                        [
                          -46.109,
                          -72.305
                        ],
                        [
                          -47.953,
                          -68.681
                        ],
                        [
                          -49.204,
                          -64.703
                        ],
                        [
                          -49.802,
                          -59.466
                        ],
                        [
                          -53.708,
                          -53.931
                        ],
                        [
                          -58.206,
                          -49.579
                        ],
                        [
                          -59.754,
                          -48.176
                        ],
                        [
                          -63.075,
                          -46.779
                        ],
                        [
                          -64.548,
                          -45.671
                        ],
                        [
                          -65.658,
                          -44.344
                        ],
                        [
                          -64.548,
                          -44.195
                        ],
                        [
                          -65.656,
                          -42.424
                        ],
                        [
                          -63.292,
                          -42.061
                        ],
                        [
                          -65.436,
                          -41.471
                        ],
                        [
                          -63.15,
                          -41.097
                        ],
                        [
                          -60.643,
                          -40.799
                        ],
                        [
                          -61.67,
                          -40.358
                        ],
                        [
                          -59.606,
                          -39.548
                        ],
                        [
                          -58.647,
                          -40.214
                        ],
                        [
                          -54.298,
                          -40.731
                        ],
                        [
                          -54.889,
                          -42.205
                        ],
                        [
                          -54.665,
                          -47.886
                        ],
                        [
                          -52.602,
                          -50.54
                        ],
                        [
                          -40.503,
                          -68.394
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 4",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 4,
                  "ty": "sh",
                  "ix": 5,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          1.685,
                          -0.761
                        ],
                        [
                          -0.154,
                          -8.121
                        ],
                        [
                          -2.147,
                          -2.915
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -3.059,
                          -1.685
                        ],
                        [
                          -2.605,
                          -3.983
                        ],
                        [
                          -5.057,
                          6.134
                        ],
                        [
                          -3.829,
                          2.913
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -3.37,
                          4.443
                        ],
                        [
                          1.994,
                          15.932
                        ],
                        [
                          -0.917,
                          3.981
                        ],
                        [
                          5.974,
                          1.068
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          3.215,
                          0.919
                        ],
                        [
                          8.735,
                          -0.92
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          2.751,
                          -1.074
                        ],
                        [
                          0,
                          -3.673
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.841,
                          -0.154
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.768,
                          -3.066
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          40.575,
                          75.878
                        ],
                        [
                          42.571,
                          70.671
                        ],
                        [
                          38.585,
                          56.119
                        ],
                        [
                          34.45,
                          47.387
                        ],
                        [
                          27.094,
                          42.484
                        ],
                        [
                          20.812,
                          36.664
                        ],
                        [
                          12.085,
                          25.938
                        ],
                        [
                          -22.389,
                          43.095
                        ],
                        [
                          -31.274,
                          45.856
                        ],
                        [
                          -43.988,
                          51.373
                        ],
                        [
                          -46.133,
                          63.323
                        ],
                        [
                          -45.673,
                          84.309
                        ],
                        [
                          -46.133,
                          94.881
                        ],
                        [
                          -37.405,
                          99.781
                        ],
                        [
                          -32.653,
                          101.312
                        ],
                        [
                          -25.454,
                          102.077
                        ],
                        [
                          -12.736,
                          102.383
                        ],
                        [
                          -8.293,
                          101.926
                        ],
                        [
                          -6.457,
                          98.091
                        ],
                        [
                          -0.174,
                          95.644
                        ],
                        [
                          0.286,
                          95.189
                        ],
                        [
                          8.253,
                          100.241
                        ],
                        [
                          9.783,
                          96.411
                        ],
                        [
                          13.767,
                          91.963
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 5",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 5,
                  "ty": "sh",
                  "ix": 6,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          -0.063,
                          -0.021
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.063,
                          3.305
                        ],
                        [
                          -3.265,
                          3.613
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.811,
                          1.465
                        ],
                        [
                          -1.549,
                          2.152
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.891,
                          -1.037
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -3.009,
                          1.983
                        ],
                        [
                          -2.662,
                          0.601
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.029,
                          2.839
                        ],
                        [
                          -0.951,
                          0.946
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.8,
                          3.095
                        ],
                        [
                          -0.083,
                          0.431
                        ],
                        [
                          -1.204,
                          -0.343
                        ],
                        [
                          -0.345,
                          -3.778
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.802,
                          -1.374
                        ],
                        [
                          -1.548,
                          0
                        ],
                        [
                          0.954,
                          -0.865
                        ],
                        [
                          -1.168,
                          0.172
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.168,
                          0.171
                        ],
                        [
                          0.086,
                          -1.031
                        ],
                        [
                          -5.277,
                          -3.092
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -6.755,
                          -1.933
                        ],
                        [
                          -2.251,
                          -1.28
                        ],
                        [
                          0.902,
                          -0.386
                        ],
                        [
                          -3.608,
                          -2.964
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          2.186,
                          -0.512
                        ],
                        [
                          -3.477,
                          -1.998
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.4,
                          0.651
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.957,
                          -0.963
                        ],
                        [
                          0.899,
                          -0.19
                        ],
                        [
                          -1.415,
                          -1.865
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.157,
                          -1.87
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.094,
                          -0.378
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.195,
                          0.839
                        ],
                        [
                          -1.162,
                          0.58
                        ],
                        [
                          -0.379,
                          2.251
                        ],
                        [
                          -0.446,
                          1.026
                        ],
                        [
                          0.262,
                          1.802
                        ],
                        [
                          0,
                          0.585
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.16,
                          0.901
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.575,
                          1.027
                        ],
                        [
                          0.514,
                          0.451
                        ],
                        [
                          -0.381,
                          0.645
                        ],
                        [
                          0.324,
                          2.581
                        ],
                        [
                          0.514,
                          0.839
                        ],
                        [
                          -0.901,
                          1.74
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.452,
                          0.261
                        ],
                        [
                          0.903,
                          -0.131
                        ],
                        [
                          0.58,
                          0.776
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.901,
                          0.514
                        ],
                        [
                          0.258,
                          1.353
                        ],
                        [
                          0.518,
                          0.441
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.258,
                          0.71
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.259,
                          0.711
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.128,
                          1.095
                        ],
                        [
                          -0.387,
                          1.413
                        ],
                        [
                          0.191,
                          1.481
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.063,
                          1.026
                        ],
                        [
                          -1.549,
                          1.214
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -13.96,
                          4.503
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.901,
                          -0.963
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.582,
                          -0.645
                        ],
                        [
                          -2.959,
                          -6.758
                        ],
                        [
                          0.065,
                          -1.419
                        ],
                        [
                          -0.902,
                          -0.452
                        ],
                        [
                          -1.478,
                          0.068
                        ],
                        [
                          -4.888,
                          0.705
                        ],
                        [
                          -6.496,
                          0.384
                        ],
                        [
                          -2.192,
                          -0.198
                        ],
                        [
                          -6.301,
                          0.454
                        ],
                        [
                          -1.672,
                          -0.065
                        ],
                        [
                          -1.16,
                          0.384
                        ],
                        [
                          -2.38,
                          -2.769
                        ],
                        [
                          -0.514,
                          -1.416
                        ],
                        [
                          -0.773,
                          -0.838
                        ],
                        [
                          1.029,
                          -2.965
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.065,
                          -1.028
                        ],
                        [
                          -0.776,
                          -0.961
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.775,
                          -0.319
                        ],
                        [
                          -0.705,
                          -1.672
                        ],
                        [
                          -0.193,
                          -4.179
                        ],
                        [
                          4.503,
                          -6.308
                        ],
                        [
                          2.96,
                          -3.34
                        ],
                        [
                          2.312,
                          -2.892
                        ],
                        [
                          0.773,
                          -0.642
                        ],
                        [
                          0.123,
                          -0.586
                        ],
                        [
                          0.512,
                          -0.648
                        ],
                        [
                          -0.578,
                          -0.517
                        ],
                        [
                          -0.514,
                          -1.288
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -8.174,
                          3.738
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.544,
                          -0.838
                        ],
                        [
                          2.186,
                          -1.996
                        ],
                        [
                          3.019,
                          -1.737
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.773,
                          -0.706
                        ],
                        [
                          -5.705,
                          0.204
                        ],
                        [
                          -4.049,
                          0.868
                        ],
                        [
                          -17.774,
                          -12.068
                        ],
                        [
                          -2.524,
                          -2.782
                        ],
                        [
                          -3.837,
                          -1.981
                        ],
                        [
                          -3.963,
                          -3.382
                        ],
                        [
                          -4.305,
                          -0.583
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -4.89,
                          -1.747
                        ],
                        [
                          1.984,
                          0.81
                        ],
                        [
                          -28.875,
                          8.62
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          5.468,
                          0.579
                        ],
                        [
                          -18.152,
                          7.09
                        ],
                        [
                          6.543,
                          -1.692
                        ],
                        [
                          -11.992,
                          3.73
                        ],
                        [
                          6.836,
                          -0.826
                        ],
                        [
                          -3.349,
                          0.883
                        ],
                        [
                          6.003,
                          -1.317
                        ],
                        [
                          -3.378,
                          0.804
                        ],
                        [
                          1.719,
                          -0.222
                        ],
                        [
                          -3.769,
                          -0.975
                        ],
                        [
                          -2.631,
                          -0.225
                        ],
                        [
                          8.069,
                          1.833
                        ],
                        [
                          1.664,
                          -0.225
                        ],
                        [
                          -5.605,
                          -0.17
                        ],
                        [
                          5.255,
                          1.024
                        ],
                        [
                          -4.877,
                          -0.115
                        ],
                        [
                          3.659,
                          1.133
                        ],
                        [
                          -2.27,
                          -2.549
                        ],
                        [
                          1.721,
                          0.455
                        ],
                        [
                          -2.628,
                          -2.116
                        ],
                        [
                          -2.066,
                          -0.117
                        ],
                        [
                          1.828,
                          0.343
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.768,
                          -0.632
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.726,
                          -1.369
                        ],
                        [
                          1.606,
                          1.222
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.732,
                          -1.609
                        ],
                        [
                          1.275,
                          3.161
                        ],
                        [
                          2.805,
                          0.515
                        ],
                        [
                          7.547,
                          -1.379
                        ],
                        [
                          4.458,
                          2.63
                        ],
                        [
                          4.403,
                          2.288
                        ],
                        [
                          5.498,
                          0.739
                        ],
                        [
                          1.031,
                          0.857
                        ],
                        [
                          2.57,
                          0.567
                        ],
                        [
                          2.392,
                          5.6
                        ],
                        [
                          -0.237,
                          3.944
                        ],
                        [
                          0.282,
                          3.72
                        ],
                        [
                          0.632,
                          -1.144
                        ],
                        [
                          -0.224,
                          -1.605
                        ],
                        [
                          -0.52,
                          1.891
                        ],
                        [
                          0.912,
                          2.4
                        ],
                        [
                          3.375,
                          -1.939
                        ],
                        [
                          2.858,
                          -2.921
                        ],
                        [
                          2.524,
                          -2.917
                        ],
                        [
                          7.724,
                          -4.41
                        ],
                        [
                          0.167,
                          -1.089
                        ],
                        [
                          -7.664,
                          -3.772
                        ],
                        [
                          -1.486,
                          -3.43
                        ],
                        [
                          4.462,
                          -2.455
                        ],
                        [
                          2.913,
                          -2.635
                        ],
                        [
                          1.311,
                          -0.739
                        ],
                        [
                          5.031,
                          -2.111
                        ],
                        [
                          1.084,
                          -1.031
                        ],
                        [
                          0.577,
                          -1.256
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.974,
                          -0.619
                        ],
                        [
                          0.797,
                          0.06
                        ],
                        [
                          -0.172,
                          -1.026
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.18,
                          -2.458
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.115,
                          -0.518
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.17,
                          -1.027
                        ],
                        [
                          2.8,
                          -3.832
                        ],
                        [
                          2.343,
                          3.947
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.058,
                          1.257
                        ],
                        [
                          0.345,
                          0.864
                        ],
                        [
                          -0.174,
                          1.252
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.144,
                          -2.113
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.315,
                          0.399
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.455,
                          -0.575
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.058,
                          -1.659
                        ],
                        [
                          0.515,
                          -0.577
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.632,
                          -0.517
                        ],
                        [
                          2.858,
                          -0.405
                        ],
                        [
                          0.624,
                          1.946
                        ],
                        [
                          -1.209,
                          3.605
                        ],
                        [
                          -0.744,
                          1.141
                        ],
                        [
                          1.486,
                          -0.69
                        ],
                        [
                          1.265,
                          -0.059
                        ],
                        [
                          1.139,
                          -0.571
                        ],
                        [
                          1.029,
                          0.118
                        ],
                        [
                          1.831,
                          -0.919
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          4.689,
                          0.92
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.828,
                          0.342
                        ],
                        [
                          4.349,
                          0.287
                        ],
                        [
                          1.139,
                          0.23
                        ],
                        [
                          0.749,
                          -0.235
                        ],
                        [
                          2.975,
                          0.737
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          4.41,
                          3.72
                        ],
                        [
                          3.433,
                          2.171
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          3.203,
                          1.427
                        ],
                        [
                          0.972,
                          4.061
                        ],
                        [
                          -0.117,
                          1.598
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.802,
                          1.946
                        ],
                        [
                          -2.461,
                          3.2
                        ],
                        [
                          -0.457,
                          1.604
                        ],
                        [
                          1.204,
                          1.426
                        ],
                        [
                          1.374,
                          0.909
                        ],
                        [
                          0.228,
                          6.971
                        ],
                        [
                          1.147,
                          2.288
                        ],
                        [
                          -0.052,
                          3.373
                        ],
                        [
                          0.917,
                          1.486
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.745,
                          0.109
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.399,
                          0.394
                        ],
                        [
                          -0.629,
                          0.919
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.69,
                          0.052
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          2.176,
                          3.2
                        ],
                        [
                          1.832,
                          4.342
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          3.608,
                          -1.115
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.775,
                          0.434
                        ],
                        [
                          0.347,
                          1.031
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.342,
                          1.455
                        ],
                        [
                          0.344,
                          -0.081
                        ],
                        [
                          1.546,
                          -0.342
                        ],
                        [
                          0.087,
                          -1.457
                        ],
                        [
                          2.489,
                          -0.084
                        ],
                        [
                          1.202,
                          0.773
                        ],
                        [
                          0.946,
                          0.94
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.084,
                          1.037
                        ],
                        [
                          0.59,
                          0.269
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          -0.843,
                          -0.436
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.176,
                          -0.066
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.227,
                          -0.07
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.263,
                          0.35
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.549,
                          0.259
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.702,
                          -0.055
                        ],
                        [
                          -0.512,
                          0.175
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.248,
                          0.088
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.342,
                          0.159
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.365,
                          0.167
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.232,
                          -0.055
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.181,
                          -0.081
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.186,
                          0.089
                        ]
                      ],
                      "v": [
                        [
                          -178.652,
                          -13.254
                        ],
                        [
                          -179.041,
                          -13.419
                        ],
                        [
                          -181.629,
                          -18.481
                        ],
                        [
                          -182.575,
                          -24.931
                        ],
                        [
                          -180.6,
                          -26.479
                        ],
                        [
                          -172.86,
                          -35.243
                        ],
                        [
                          -174.067,
                          -38.683
                        ],
                        [
                          -170.8,
                          -42.808
                        ],
                        [
                          -167.104,
                          -43.059
                        ],
                        [
                          -160.228,
                          -53.115
                        ],
                        [
                          -153.008,
                          -61.37
                        ],
                        [
                          -150.777,
                          -64.977
                        ],
                        [
                          -147.938,
                          -65.494
                        ],
                        [
                          -145.106,
                          -69.791
                        ],
                        [
                          -142.868,
                          -73.232
                        ],
                        [
                          -142.437,
                          -73.744
                        ],
                        [
                          -141.671,
                          -80.535
                        ],
                        [
                          -141.066,
                          -82.335
                        ],
                        [
                          -139.945,
                          -84.398
                        ],
                        [
                          -136.682,
                          -79.247
                        ],
                        [
                          -136.338,
                          -77.095
                        ],
                        [
                          -133.072,
                          -78.9
                        ],
                        [
                          -134.705,
                          -77.27
                        ],
                        [
                          -131.009,
                          -77.787
                        ],
                        [
                          -135.293,
                          -75.645
                        ],
                        [
                          -131.092,
                          -77.014
                        ],
                        [
                          -135.126,
                          -75.123
                        ],
                        [
                          -130.063,
                          -76.581
                        ],
                        [
                          -133.417,
                          -74.086
                        ],
                        [
                          -123.488,
                          -71.398
                        ],
                        [
                          -123.941,
                          -71.145
                        ],
                        [
                          -111.65,
                          -65.737
                        ],
                        [
                          -105.794,
                          -63.747
                        ],
                        [
                          -108.563,
                          -63.747
                        ],
                        [
                          -98.521,
                          -59.171
                        ],
                        [
                          -100.261,
                          -59.693
                        ],
                        [
                          -100.074,
                          -59.045
                        ],
                        [
                          -103.735,
                          -58.794
                        ],
                        [
                          -95.755,
                          -56.344
                        ],
                        [
                          -89.324,
                          -53.578
                        ],
                        [
                          -95.18,
                          -54.229
                        ],
                        [
                          -93.313,
                          -53.254
                        ],
                        [
                          -94.919,
                          -53.254
                        ],
                        [
                          -87.135,
                          -51.196
                        ],
                        [
                          -89.131,
                          -50.94
                        ],
                        [
                          -83.471,
                          -48.111
                        ],
                        [
                          -84.306,
                          -48.111
                        ],
                        [
                          -81.152,
                          -45.211
                        ],
                        [
                          -81.924,
                          -45.342
                        ],
                        [
                          -80.122,
                          -43.997
                        ],
                        [
                          -77.614,
                          -43.482
                        ],
                        [
                          -76.58,
                          -45.086
                        ],
                        [
                          -74.775,
                          -48.111
                        ],
                        [
                          -74.396,
                          -51.326
                        ],
                        [
                          -73.108,
                          -61.49
                        ],
                        [
                          -72.915,
                          -64.387
                        ],
                        [
                          -73.231,
                          -67.03
                        ],
                        [
                          -73.879,
                          -68.762
                        ],
                        [
                          -73.748,
                          -70.502
                        ],
                        [
                          -73.489,
                          -72.947
                        ],
                        [
                          -74.134,
                          -75.256
                        ],
                        [
                          -74.197,
                          -76.162
                        ],
                        [
                          -73.944,
                          -77.194
                        ],
                        [
                          -76.967,
                          -83.372
                        ],
                        [
                          -77.867,
                          -85.749
                        ],
                        [
                          -78.899,
                          -90.127
                        ],
                        [
                          -78.572,
                          -90.829
                        ],
                        [
                          -79.735,
                          -91.989
                        ],
                        [
                          -80.827,
                          -92.828
                        ],
                        [
                          -81.921,
                          -92.12
                        ],
                        [
                          -83.528,
                          -92.765
                        ],
                        [
                          -85.395,
                          -91.477
                        ],
                        [
                          -88.1,
                          -90.636
                        ],
                        [
                          -89.256,
                          -91.927
                        ],
                        [
                          -89.579,
                          -93.081
                        ],
                        [
                          -90.223,
                          -93.28
                        ],
                        [
                          -90.991,
                          -94.178
                        ],
                        [
                          -91.574,
                          -94.306
                        ],
                        [
                          -92.085,
                          -95.205
                        ],
                        [
                          -92.407,
                          -95.855
                        ],
                        [
                          -93.18,
                          -95.725
                        ],
                        [
                          -94.917,
                          -96.237
                        ],
                        [
                          -94.53,
                          -99.583
                        ],
                        [
                          -96.267,
                          -103.122
                        ],
                        [
                          -97.234,
                          -102.861
                        ],
                        [
                          -98.264,
                          -103.762
                        ],
                        [
                          -101.8,
                          -103.762
                        ],
                        [
                          -98.84,
                          -105.181
                        ],
                        [
                          -88.165,
                          -122.233
                        ],
                        [
                          -85.265,
                          -122.81
                        ],
                        [
                          -83.141,
                          -122.748
                        ],
                        [
                          -81.921,
                          -122.486
                        ],
                        [
                          -80.179,
                          -121.653
                        ],
                        [
                          -72.527,
                          -113.67
                        ],
                        [
                          -71.238,
                          -109.553
                        ],
                        [
                          -69.568,
                          -108.976
                        ],
                        [
                          -66.866,
                          -108.851
                        ],
                        [
                          -55.865,
                          -109.809
                        ],
                        [
                          -45.315,
                          -110.841
                        ],
                        [
                          -42.219,
                          -110.711
                        ],
                        [
                          -31.091,
                          -110.65
                        ],
                        [
                          -28.26,
                          -110.52
                        ],
                        [
                          -25.3,
                          -110.841
                        ],
                        [
                          -19.962,
                          -109.809
                        ],
                        [
                          -17.065,
                          -107.751
                        ],
                        [
                          -14.811,
                          -104.149
                        ],
                        [
                          -13.329,
                          -98.744
                        ],
                        [
                          -13.915,
                          -96.882
                        ],
                        [
                          -13.264,
                          -95.464
                        ],
                        [
                          -10.561,
                          -93.217
                        ],
                        [
                          -9.6,
                          -92.185
                        ],
                        [
                          -8.63,
                          -91.608
                        ],
                        [
                          -6.19,
                          -89.351
                        ],
                        [
                          -3.484,
                          -82.534
                        ],
                        [
                          -6.77,
                          -71.21
                        ],
                        [
                          -11.66,
                          -65.55
                        ],
                        [
                          -25.747,
                          -48.949
                        ],
                        [
                          -28.644,
                          -45.601
                        ],
                        [
                          -29.477,
                          -44.312
                        ],
                        [
                          -29.736,
                          -42.834
                        ],
                        [
                          -29.354,
                          -41.16
                        ],
                        [
                          -27.098,
                          -38.717
                        ],
                        [
                          -26.648,
                          -37.497
                        ],
                        [
                          -23.436,
                          -37.174
                        ],
                        [
                          -23.238,
                          -36.531
                        ],
                        [
                          -4.578,
                          -39.556
                        ],
                        [
                          1.34,
                          -43.349
                        ],
                        [
                          6.035,
                          -45.086
                        ],
                        [
                          4.75,
                          -42.126
                        ],
                        [
                          -2.329,
                          -36.656
                        ],
                        [
                          -0.524,
                          -36.98
                        ],
                        [
                          4.107,
                          -36.656
                        ],
                        [
                          19.42,
                          -38.579
                        ],
                        [
                          32.146,
                          -40.17
                        ],
                        [
                          64.636,
                          -32.613
                        ],
                        [
                          81.474,
                          -21.67
                        ],
                        [
                          88.669,
                          -17.049
                        ],
                        [
                          110.559,
                          -1.91
                        ],
                        [
                          118.821,
                          1.113
                        ],
                        [
                          115.909,
                          1.342
                        ],
                        [
                          127.787,
                          8.565
                        ],
                        [
                          120.462,
                          7.52
                        ],
                        [
                          160.854,
                          13.455
                        ],
                        [
                          152.939,
                          16.482
                        ],
                        [
                          141.179,
                          17.878
                        ],
                        [
                          168.982,
                          13.692
                        ],
                        [
                          153.172,
                          19.742
                        ],
                        [
                          172.148,
                          17.642
                        ],
                        [
                          161.138,
                          21.715
                        ],
                        [
                          172.792,
                          20.103
                        ],
                        [
                          162.016,
                          23.003
                        ],
                        [
                          169.81,
                          21.963
                        ],
                        [
                          163.836,
                          23.742
                        ],
                        [
                          172.696,
                          24.489
                        ],
                        [
                          176.13,
                          25.056
                        ],
                        [
                          167.669,
                          24.254
                        ],
                        [
                          164.636,
                          24.371
                        ],
                        [
                          177.443,
                          27.289
                        ],
                        [
                          167.914,
                          27.122
                        ],
                        [
                          178.597,
                          29.924
                        ],
                        [
                          172.199,
                          29.64
                        ],
                        [
                          180.59,
                          34.953
                        ],
                        [
                          177.219,
                          33.179
                        ],
                        [
                          181.568,
                          36.899
                        ],
                        [
                          185,
                          37.701
                        ],
                        [
                          181.106,
                          37.925
                        ],
                        [
                          183.172,
                          38.667
                        ],
                        [
                          182.654,
                          39.015
                        ],
                        [
                          184.882,
                          41.016
                        ],
                        [
                          182.654,
                          40.961
                        ],
                        [
                          185.84,
                          43.753
                        ],
                        [
                          180.196,
                          41.473
                        ],
                        [
                          180.938,
                          42.734
                        ],
                        [
                          179.966,
                          42.1
                        ],
                        [
                          183.726,
                          48.275
                        ],
                        [
                          179.335,
                          43.698
                        ],
                        [
                          175.793,
                          41.815
                        ],
                        [
                          165.268,
                          41.763
                        ],
                        [
                          145.422,
                          42.447
                        ],
                        [
                          132.557,
                          32.665
                        ],
                        [
                          123.113,
                          28.893
                        ],
                        [
                          118.543,
                          27.234
                        ],
                        [
                          111.163,
                          27.406
                        ],
                        [
                          100.417,
                          22.373
                        ],
                        [
                          97.268,
                          15.339
                        ],
                        [
                          98.013,
                          6.755
                        ],
                        [
                          97.319,
                          9.213
                        ],
                        [
                          95.831,
                          13.735
                        ],
                        [
                          95.779,
                          11.041
                        ],
                        [
                          95.898,
                          3.895
                        ],
                        [
                          90.059,
                          10.757
                        ],
                        [
                          82.91,
                          15.456
                        ],
                        [
                          74.384,
                          23.804
                        ],
                        [
                          59.691,
                          35.183
                        ],
                        [
                          57.178,
                          37.528
                        ],
                        [
                          67.752,
                          45.932
                        ],
                        [
                          78.965,
                          53.596
                        ],
                        [
                          76.56,
                          61.027
                        ],
                        [
                          69.413,
                          66.408
                        ],
                        [
                          63.81,
                          70.807
                        ],
                        [
                          59.007,
                          77.215
                        ],
                        [
                          46.309,
                          84.596
                        ],
                        [
                          43.219,
                          88.366
                        ],
                        [
                          42.709,
                          90.197
                        ],
                        [
                          41.564,
                          92.368
                        ],
                        [
                          40.016,
                          93.17
                        ],
                        [
                          39.05,
                          94.426
                        ],
                        [
                          39.332,
                          95.693
                        ],
                        [
                          42.827,
                          97.916
                        ],
                        [
                          42.882,
                          98.6
                        ],
                        [
                          43.796,
                          100.15
                        ],
                        [
                          44.196,
                          100.322
                        ],
                        [
                          44.593,
                          101.636
                        ],
                        [
                          41.39,
                          113.589
                        ],
                        [
                          36.477,
                          111.01
                        ],
                        [
                          33.553,
                          106.554
                        ],
                        [
                          32.185,
                          103.866
                        ],
                        [
                          31.153,
                          99.745
                        ],
                        [
                          30.753,
                          97.179
                        ],
                        [
                          31.09,
                          93.517
                        ],
                        [
                          21.261,
                          101.061
                        ],
                        [
                          20.34,
                          102.493
                        ],
                        [
                          17.371,
                          104.551
                        ],
                        [
                          16.397,
                          104.321
                        ],
                        [
                          14.741,
                          105.238
                        ],
                        [
                          13.707,
                          106.837
                        ],
                        [
                          15.943,
                          109.757
                        ],
                        [
                          15.37,
                          112.102
                        ],
                        [
                          14.686,
                          113.474
                        ],
                        [
                          15.253,
                          114.101
                        ],
                        [
                          15.023,
                          115.19
                        ],
                        [
                          4.392,
                          123.369
                        ],
                        [
                          2.676,
                          121.765
                        ],
                        [
                          2.333,
                          111.695
                        ],
                        [
                          4.449,
                          106.15
                        ],
                        [
                          1.362,
                          106.779
                        ],
                        [
                          -1.559,
                          107.468
                        ],
                        [
                          -3.673,
                          107.98
                        ],
                        [
                          -7.162,
                          108.777
                        ],
                        [
                          -11.393,
                          110.274
                        ],
                        [
                          -13.225,
                          111.125
                        ],
                        [
                          -20.714,
                          112.439
                        ],
                        [
                          -26.665,
                          110.841
                        ],
                        [
                          -36.1,
                          108.435
                        ],
                        [
                          -45.594,
                          106.834
                        ],
                        [
                          -48.452,
                          106.834
                        ],
                        [
                          -49.883,
                          107.014
                        ],
                        [
                          -54.917,
                          106.554
                        ],
                        [
                          -58.691,
                          106.724
                        ],
                        [
                          -69.161,
                          104.321
                        ],
                        [
                          -76.824,
                          97.574
                        ],
                        [
                          -79.456,
                          95.401
                        ],
                        [
                          -86.772,
                          90.424
                        ],
                        [
                          -92.148,
                          84.704
                        ],
                        [
                          -93.005,
                          81.504
                        ],
                        [
                          -93.462,
                          80.355
                        ],
                        [
                          -93.519,
                          76.755
                        ],
                        [
                          -89.061,
                          69.151
                        ],
                        [
                          -78.821,
                          50.56
                        ],
                        [
                          -83.342,
                          46.509
                        ],
                        [
                          -85.855,
                          44.393
                        ],
                        [
                          -91.691,
                          33.927
                        ],
                        [
                          -93.352,
                          29.405
                        ],
                        [
                          -98.156,
                          16.657
                        ],
                        [
                          -102.1,
                          10.078
                        ],
                        [
                          -102.329,
                          10.762
                        ],
                        [
                          -103.529,
                          11.969
                        ],
                        [
                          -104.446,
                          12.771
                        ],
                        [
                          -105.245,
                          12.943
                        ],
                        [
                          -105.36,
                          11.906
                        ],
                        [
                          -104.673,
                          11.109
                        ],
                        [
                          -103.756,
                          9.908
                        ],
                        [
                          -102.954,
                          8.764
                        ],
                        [
                          -113.024,
                          -5.133
                        ],
                        [
                          -123.319,
                          -21.833
                        ],
                        [
                          -124.824,
                          -24.669
                        ],
                        [
                          -145.106,
                          -22.692
                        ],
                        [
                          -151.721,
                          -19.257
                        ],
                        [
                          -152.324,
                          -17.797
                        ],
                        [
                          -150.088,
                          -10.402
                        ],
                        [
                          -150.691,
                          -9.548
                        ],
                        [
                          -151.467,
                          -10.835
                        ],
                        [
                          -153.1,
                          -16.595
                        ],
                        [
                          -155.244,
                          -17.883
                        ],
                        [
                          -161.001,
                          -15.221
                        ],
                        [
                          -163.152,
                          -14.184
                        ],
                        [
                          -165.988,
                          -11.439
                        ],
                        [
                          -169.337,
                          -8.602
                        ],
                        [
                          -173.29,
                          -9.033
                        ],
                        [
                          -176.904,
                          -10.488
                        ],
                        [
                          -177.074,
                          -11.609
                        ],
                        [
                          -177.847,
                          -12.646
                        ],
                        [
                          -179.163,
                          -13.474
                        ],
                        [
                          -179.041,
                          -13.419
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 6",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 6,
                  "ty": "sh",
                  "ix": 7,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          1.57,
                          -0.661
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          -142.11,
                          -24.476
                        ],
                        [
                          -126.275,
                          -26.14
                        ],
                        [
                          -126.701,
                          -26.631
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 7",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 7,
                  "ty": "sh",
                  "ix": 8,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          -5.368,
                          -0.765
                        ],
                        [
                          1.525,
                          4.752
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          106.758,
                          14.915
                        ],
                        [
                          114.268,
                          23.794
                        ],
                        [
                          107.376,
                          14.604
                        ],
                        [
                          106.144,
                          11.232
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 8",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 8,
                  "ty": "sh",
                  "ix": 9,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          -3.827,
                          0.614
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          116.253,
                          25.784
                        ],
                        [
                          110.436,
                          24.713
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 9",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 9,
                  "ty": "sh",
                  "ix": 10,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.146,
                          0.045
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          -2.826,
                          0.146
                        ],
                        [
                          3.98,
                          3.971
                        ]
                      ],
                      "v": [
                        [
                          110.283,
                          25.938
                        ],
                        [
                          107.215,
                          23.334
                        ],
                        [
                          101.704,
                          22.579
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 10",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 10,
                  "ty": "sh",
                  "ix": 11,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          1.065,
                          4.9
                        ],
                        [
                          -2.601,
                          -0.612
                        ]
                      ],
                      "v": [
                        [
                          100.022,
                          17.517
                        ],
                        [
                          106.144,
                          21.804
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 11",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "mm",
                  "mm": 1,
                  "nm": "Merge Paths 1",
                  "mn": "ADBE Vector Filter - Merge",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [
                      0.952941176471,
                      0.325490196078,
                      1,
                      1
                    ],
                    "ix": 4
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 5
                  },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": {
                    "a": 0,
                    "k": [
                      186.09,
                      123.961
                    ],
                    "ix": 2
                  },
                  "a": {
                    "a": 0,
                    "k": [
                      0,
                      0
                    ],
                    "ix": 1
                  },
                  "s": {
                    "a": 0,
                    "k": [
                      100,
                      100
                    ],
                    "ix": 3
                  },
                  "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 6
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 7
                  },
                  "sk": {
                    "a": 0,
                    "k": 0,
                    "ix": 4
                  },
                  "sa": {
                    "a": 0,
                    "k": 0,
                    "ix": 5
                  },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 13,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 31.0000012626559,
          "op": 61.0000024845809,
          "st": -29.0000011811942,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 5,
          "ty": 4,
          "nm": "Layer 1 Outlines",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [
                955.665,
                540.482,
                0
              ],
              "ix": 2,
              "l": 2
            },
            "a": {
              "a": 0,
              "k": [
                168.384,
                127.586,
                0
              ],
              "ix": 1,
              "l": 2
            },
            "s": {
              "a": 0,
              "k": [
                400,
                400,
                100
              ],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          -1.541,
                          -0.69
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          -139.058,
                          -20.836
                        ],
                        [
                          -139.058,
                          -22.141
                        ],
                        [
                          -139.986,
                          -23.529
                        ],
                        [
                          -140.99,
                          -22.607
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          -1.789,
                          0.209
                        ],
                        [
                          0.279,
                          0.755
                        ],
                        [
                          1.308,
                          0.478
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          -63.939,
                          -47.667
                        ],
                        [
                          -65.187,
                          -49.839
                        ],
                        [
                          -71.694,
                          -48.081
                        ],
                        [
                          -70.455,
                          -46.63
                        ],
                        [
                          -67.46,
                          -46.261
                        ],
                        [
                          -68.837,
                          -45.634
                        ],
                        [
                          -67.35,
                          -45.534
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 2,
                  "ty": "sh",
                  "ix": 3,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.097,
                          0.211
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          -51.686,
                          -45.293
                        ],
                        [
                          -46.515,
                          -46.461
                        ],
                        [
                          -49.613,
                          -48.048
                        ],
                        [
                          -51.405,
                          -46.841
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 3",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 3,
                  "ty": "sh",
                  "ix": 4,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0.28,
                          -0.444
                        ],
                        [
                          -0.83,
                          1.098
                        ],
                        [
                          -2.722,
                          4.72
                        ],
                        [
                          -1.58,
                          1.622
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.689,
                          0.822
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.172,
                          -0.551
                        ],
                        [
                          -0.108,
                          -0.59
                        ],
                        [
                          0.478,
                          -1.207
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.031,
                          -0.557
                        ],
                        [
                          0.308,
                          -0.306
                        ],
                        [
                          0,
                          -0.442
                        ]
                      ],
                      "v": [
                        [
                          -44.696,
                          -65.401
                        ],
                        [
                          -43.692,
                          -69.74
                        ],
                        [
                          -45.795,
                          -64.581
                        ],
                        [
                          -51.858,
                          -57.521
                        ],
                        [
                          -54.783,
                          -54.897
                        ],
                        [
                          -55.642,
                          -53.933
                        ],
                        [
                          -56.332,
                          -52.35
                        ],
                        [
                          -54.197,
                          -51.763
                        ],
                        [
                          -49.132,
                          -55.93
                        ],
                        [
                          -48.376,
                          -57.758
                        ],
                        [
                          -47.514,
                          -59.095
                        ],
                        [
                          -46.858,
                          -60.129
                        ],
                        [
                          -46.103,
                          -62.13
                        ],
                        [
                          -45.309,
                          -64.337
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 4",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 4,
                  "ty": "sh",
                  "ix": 5,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          -0.162,
                          -2.861
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.099,
                          0.423
                        ],
                        [
                          0,
                          0.442
                        ],
                        [
                          0.64,
                          -0.711
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          -43.512,
                          -73.37
                        ],
                        [
                          -42.561,
                          -76.865
                        ],
                        [
                          -42.764,
                          -78.008
                        ],
                        [
                          -43.316,
                          -79.206
                        ],
                        [
                          -44.465,
                          -79.72
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 5",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 5,
                  "ty": "sh",
                  "ix": 6,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          -0.611,
                          -1.685
                        ],
                        [
                          -0.692,
                          0.648
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.86,
                          1.293
                        ]
                      ],
                      "v": [
                        [
                          -31.187,
                          -34.93
                        ],
                        [
                          -27.944,
                          -34.201
                        ],
                        [
                          -30.624,
                          -40.461
                        ],
                        [
                          -32.35,
                          -39.732
                        ],
                        [
                          -32.655,
                          -38.517
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 6",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 6,
                  "ty": "sh",
                  "ix": 7,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0.28,
                          -0.507
                        ],
                        [
                          0.115,
                          -0.285
                        ],
                        [
                          0.28,
                          -0.28
                        ],
                        [
                          0.283,
                          -0.454
                        ],
                        [
                          0.387,
                          -0.439
                        ],
                        [
                          0.671,
                          -1.455
                        ],
                        [
                          0.334,
                          -0.335
                        ],
                        [
                          0.896,
                          -0.173
                        ],
                        [
                          -1.285,
                          -6.225
                        ],
                        [
                          -0.061,
                          -0.509
                        ],
                        [
                          -0.394,
                          0
                        ],
                        [
                          -1.742,
                          0.784
                        ],
                        [
                          -2.688,
                          0.559
                        ],
                        [
                          -2.02,
                          0.389
                        ],
                        [
                          -4.096,
                          -0.559
                        ],
                        [
                          -1.627,
                          0.956
                        ],
                        [
                          -3.078,
                          0.17
                        ],
                        [
                          -1.734,
                          -0.224
                        ],
                        [
                          -3.312,
                          -3.37
                        ],
                        [
                          0.279,
                          -2.633
                        ],
                        [
                          1.069,
                          -0.729
                        ],
                        [
                          0.282,
                          -0.334
                        ],
                        [
                          -0.951,
                          -0.841
                        ],
                        [
                          -1.12,
                          -8.179
                        ],
                        [
                          3.252,
                          -4.031
                        ],
                        [
                          1.176,
                          -2.638
                        ],
                        [
                          0.846,
                          -1.567
                        ],
                        [
                          1.066,
                          -1.293
                        ],
                        [
                          0.28,
                          -1.063
                        ],
                        [
                          0.732,
                          -0.559
                        ],
                        [
                          0.384,
                          -0.778
                        ],
                        [
                          0.115,
                          -0.397
                        ],
                        [
                          0.337,
                          -0.23
                        ],
                        [
                          0,
                          -1.008
                        ],
                        [
                          0.115,
                          -0.398
                        ],
                        [
                          -0.28,
                          -0.452
                        ],
                        [
                          -0.17,
                          -1.121
                        ],
                        [
                          -0.671,
                          -1.121
                        ],
                        [
                          -0.288,
                          -1.797
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -3.531,
                          3.137
                        ],
                        [
                          -2.579,
                          -0.623
                        ],
                        [
                          -0.055,
                          -1.009
                        ],
                        [
                          1.29,
                          -2.576
                        ],
                        [
                          1.962,
                          -0.951
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.335,
                          -0.505
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -3.271,
                          0.181
                        ],
                        [
                          -1.353,
                          0.496
                        ],
                        [
                          -13.495,
                          -8.069
                        ],
                        [
                          -2.409,
                          -1.91
                        ],
                        [
                          -4.445,
                          -3.808
                        ],
                        [
                          -3.385,
                          -0.852
                        ],
                        [
                          -7.408,
                          -7.196
                        ],
                        [
                          -6.564,
                          -0.415
                        ],
                        [
                          -6.377,
                          -12.204
                        ],
                        [
                          13.886,
                          3.971
                        ],
                        [
                          -3.122,
                          -8.542
                        ],
                        [
                          4.871,
                          1.481
                        ],
                        [
                          9.939,
                          2.32
                        ],
                        [
                          -5.334,
                          -5.12
                        ],
                        [
                          -7.828,
                          -8.254
                        ],
                        [
                          -5.715,
                          -1.053
                        ],
                        [
                          -3.6,
                          3.584
                        ],
                        [
                          3.066,
                          -1.244
                        ],
                        [
                          -4.101,
                          3.067
                        ],
                        [
                          3.887,
                          -1.448
                        ],
                        [
                          -3.892,
                          2.657
                        ],
                        [
                          13.134,
                          1.039
                        ],
                        [
                          9.527,
                          6.979
                        ],
                        [
                          6.141,
                          10.158
                        ],
                        [
                          6.35,
                          3.179
                        ],
                        [
                          3.808,
                          -1.904
                        ],
                        [
                          4.022,
                          2.756
                        ],
                        [
                          13.335,
                          -13.764
                        ],
                        [
                          0.264,
                          -10.644
                        ],
                        [
                          -2.636,
                          -9.592
                        ],
                        [
                          1.847,
                          -3.612
                        ],
                        [
                          2.202,
                          -4.315
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          7.193,
                          0
                        ],
                        [
                          1.269,
                          -1.904
                        ],
                        [
                          3.383,
                          1.486
                        ],
                        [
                          0.209,
                          3.388
                        ],
                        [
                          -8.043,
                          0.423
                        ],
                        [
                          -2.651,
                          0.279
                        ],
                        [
                          -1.818,
                          4.187
                        ],
                        [
                          -0.559,
                          8.934
                        ],
                        [
                          2.095,
                          6.277
                        ],
                        [
                          0.42,
                          5.165
                        ],
                        [
                          0.979,
                          1.4
                        ],
                        [
                          2.234,
                          -12.703
                        ],
                        [
                          0,
                          -2.515
                        ],
                        [
                          5.169,
                          -1.807
                        ],
                        [
                          7.127,
                          -3.216
                        ],
                        [
                          1.956,
                          -1.534
                        ],
                        [
                          0.559,
                          0.695
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.841,
                          -1.254
                        ],
                        [
                          2.228,
                          -0.554
                        ],
                        [
                          1.394,
                          2.09
                        ],
                        [
                          -1.394,
                          2.098
                        ],
                        [
                          -3.631,
                          1.821
                        ],
                        [
                          -3.072,
                          0.974
                        ],
                        [
                          -0.979,
                          0.841
                        ],
                        [
                          -6.005,
                          2.377
                        ],
                        [
                          -0.839,
                          0.835
                        ],
                        [
                          -1.26,
                          5.305
                        ],
                        [
                          0.282,
                          2.372
                        ],
                        [
                          -2.37,
                          3.918
                        ],
                        [
                          3.843,
                          -1.513
                        ],
                        [
                          8.8,
                          -0.269
                        ],
                        [
                          3.49,
                          -0.561
                        ],
                        [
                          6.702,
                          2.234
                        ],
                        [
                          3.633,
                          -0.844
                        ],
                        [
                          2.654,
                          -0.979
                        ],
                        [
                          5.164,
                          0.136
                        ],
                        [
                          3.213,
                          -1.954
                        ],
                        [
                          -1.818,
                          -2.79
                        ],
                        [
                          -6.426,
                          -2.513
                        ],
                        [
                          -0.559,
                          -0.982
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -3.351,
                          0.698
                        ],
                        [
                          -4.752,
                          -4.747
                        ],
                        [
                          3.212,
                          -1.536
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          2.377,
                          -0.142
                        ],
                        [
                          1.679,
                          0.143
                        ],
                        [
                          1.815,
                          -0.559
                        ],
                        [
                          2.095,
                          1.261
                        ],
                        [
                          1.397,
                          2.369
                        ],
                        [
                          3.484,
                          3.213
                        ],
                        [
                          0,
                          3.774
                        ],
                        [
                          -1.397,
                          3.215
                        ],
                        [
                          5.587,
                          -9.777
                        ],
                        [
                          1.677,
                          -3.9
                        ],
                        [
                          2.089,
                          -1.4
                        ],
                        [
                          0.417,
                          -0.974
                        ],
                        [
                          -0.559,
                          -0.559
                        ],
                        [
                          -0.141,
                          -0.972
                        ],
                        [
                          2.09,
                          -1.538
                        ],
                        [
                          5.031,
                          -0.698
                        ],
                        [
                          -0.279,
                          4.188
                        ],
                        [
                          -1.536,
                          3.216
                        ],
                        [
                          -0.557,
                          1.68
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -4.47,
                          4.884
                        ],
                        [
                          -0.697,
                          2.233
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -3.637,
                          2.516
                        ],
                        [
                          -3.351,
                          1.818
                        ],
                        [
                          -5.449,
                          2.793
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.857,
                          14.264
                        ],
                        [
                          2.437,
                          6.1
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          1.828
                        ],
                        [
                          1.586,
                          4.999
                        ],
                        [
                          1.457,
                          0.243
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          4.268,
                          -0.605
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.099,
                          -0.118
                        ],
                        [
                          1.097,
                          0.606
                        ],
                        [
                          0.734,
                          1.468
                        ],
                        [
                          0.849,
                          -1.586
                        ],
                        [
                          0.859,
                          0.117
                        ],
                        [
                          3.177,
                          0.603
                        ],
                        [
                          1.711,
                          1.338
                        ],
                        [
                          0.732,
                          0
                        ],
                        [
                          0,
                          3.422
                        ],
                        [
                          0.851,
                          0.731
                        ],
                        [
                          -3.169,
                          4.514
                        ],
                        [
                          -0.972,
                          1.833
                        ],
                        [
                          -1.466,
                          2.927
                        ],
                        [
                          -1.097,
                          0.846
                        ],
                        [
                          -1.217,
                          -0.491
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.197,
                          1.585
                        ],
                        [
                          -1.097,
                          1.706
                        ],
                        [
                          -1.586,
                          0.371
                        ],
                        [
                          -0.857,
                          0.729
                        ],
                        [
                          -2.072,
                          1.468
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.096,
                          -0.857
                        ],
                        [
                          0.849,
                          -1.586
                        ],
                        [
                          -2.197,
                          2.928
                        ],
                        [
                          -0.853,
                          -0.369
                        ],
                        [
                          1.581,
                          -1.828
                        ],
                        [
                          -0.485,
                          -0.846
                        ],
                        [
                          -1.337,
                          0.729
                        ],
                        [
                          -3.657,
                          -1.458
                        ],
                        [
                          2.317,
                          -0.246
                        ],
                        [
                          -1.956,
                          -1.1
                        ],
                        [
                          2.194,
                          -0.731
                        ],
                        [
                          -1.709,
                          -1.097
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.951,
                          -0.852
                        ],
                        [
                          -1.955,
                          0.125
                        ],
                        [
                          2.32,
                          0.49
                        ],
                        [
                          -1.706,
                          -0.368
                        ],
                        [
                          2.074,
                          0.608
                        ],
                        [
                          -3.905,
                          -0.734
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.945,
                          0.609
                        ],
                        [
                          -0.489,
                          -1.214
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.825,
                          1.701
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -1.7,
                          2.445
                        ],
                        [
                          -0.054,
                          0.836
                        ],
                        [
                          -0.672,
                          0.73
                        ],
                        [
                          0.222,
                          1.513
                        ],
                        [
                          -0.564,
                          0.676
                        ],
                        [
                          0.164,
                          1.121
                        ],
                        [
                          0.732,
                          0.951
                        ],
                        [
                          0.898,
                          2.575
                        ],
                        [
                          1.176,
                          0.784
                        ],
                        [
                          1.509,
                          2.855
                        ],
                        [
                          0.789,
                          0.836
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.673,
                          0.559
                        ],
                        [
                          1.402,
                          -0.558
                        ],
                        [
                          0.781,
                          -0.392
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.118,
                          1.008
                        ],
                        [
                          0.895,
                          1.063
                        ],
                        [
                          0.726,
                          0.107
                        ],
                        [
                          0,
                          1.343
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.452,
                          -0.337
                        ],
                        [
                          0.502,
                          0.504
                        ],
                        [
                          0.674,
                          -0.057
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.506,
                          1.186
                        ],
                        [
                          0.386,
                          2.079
                        ],
                        [
                          0.224,
                          1.957
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          1.009
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.677,
                          1.071
                        ],
                        [
                          -2.299,
                          2.576
                        ],
                        [
                          -15.913,
                          2.801
                        ],
                        [
                          0.279,
                          0.956
                        ],
                        [
                          -1.175,
                          1.121
                        ],
                        [
                          -0.11,
                          -0.612
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.479,
                          -0.765
                        ],
                        [
                          0.496,
                          0.249
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.306,
                          0.118
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.196,
                          0.262
                        ],
                        [
                          0.501,
                          -0.071
                        ],
                        [
                          -0.199,
                          0.198
                        ],
                        [
                          0.458,
                          -0.058
                        ],
                        [
                          -0.201,
                          0.413
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.369,
                          0.11
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          -79.846,
                          -126.552
                        ],
                        [
                          -79.287,
                          -126.214
                        ],
                        [
                          -78.838,
                          -125.548
                        ],
                        [
                          -77.885,
                          -125.094
                        ],
                        [
                          -77.268,
                          -124.482
                        ],
                        [
                          -76.594,
                          -122.855
                        ],
                        [
                          -76.207,
                          -122.183
                        ],
                        [
                          -77.046,
                          -121.175
                        ],
                        [
                          -69.536,
                          -110.8
                        ],
                        [
                          -68.975,
                          -109.12
                        ],
                        [
                          -68.025,
                          -109.513
                        ],
                        [
                          -59.501,
                          -111.927
                        ],
                        [
                          -51.717,
                          -113.997
                        ],
                        [
                          -45.773,
                          -114.674
                        ],
                        [
                          -37.311,
                          -115.005
                        ],
                        [
                          -33.384,
                          -115.737
                        ],
                        [
                          -29.691,
                          -116.411
                        ],
                        [
                          -25.264,
                          -117.026
                        ],
                        [
                          -15.847,
                          -113.6
                        ],
                        [
                          -13.663,
                          -108.621
                        ],
                        [
                          -14.337,
                          -106.996
                        ],
                        [
                          -14.954,
                          -105.649
                        ],
                        [
                          -11.866,
                          -102.849
                        ],
                        [
                          -4.191,
                          -91.081
                        ],
                        [
                          -6.66,
                          -80.935
                        ],
                        [
                          -9.066,
                          -75.443
                        ],
                        [
                          -12.712,
                          -67.425
                        ],
                        [
                          -16.52,
                          -60.701
                        ],
                        [
                          -17.809,
                          -58.238
                        ],
                        [
                          -18.764,
                          -56.501
                        ],
                        [
                          -19.598,
                          -55.386
                        ],
                        [
                          -20.447,
                          -53.753
                        ],
                        [
                          -20.946,
                          -52.912
                        ],
                        [
                          -20.387,
                          -51.008
                        ],
                        [
                          -20.447,
                          -49.043
                        ],
                        [
                          -20.273,
                          -47.477
                        ],
                        [
                          -19.436,
                          -44.844
                        ],
                        [
                          -17.639,
                          -42.214
                        ],
                        [
                          -16.684,
                          -39.128
                        ],
                        [
                          -14.731,
                          -33.859
                        ],
                        [
                          -3.629,
                          -40.641
                        ],
                        [
                          2.199,
                          -42.711
                        ],
                        [
                          3.371,
                          -41.204
                        ],
                        [
                          4.16,
                          -37.503
                        ],
                        [
                          0.236,
                          -33.581
                        ],
                        [
                          2.366,
                          -33.3
                        ],
                        [
                          3.486,
                          -32.571
                        ],
                        [
                          4.324,
                          -31.229
                        ],
                        [
                          16.353,
                          -32.969
                        ],
                        [
                          20.17,
                          -33.833
                        ],
                        [
                          50.115,
                          -32.472
                        ],
                        [
                          63.608,
                          -24.032
                        ],
                        [
                          70.147,
                          -20.404
                        ],
                        [
                          77.767,
                          -18.071
                        ],
                        [
                          95.337,
                          -9.607
                        ],
                        [
                          112.48,
                          -3.896
                        ],
                        [
                          135.933,
                          9.578
                        ],
                        [
                          117.358,
                          -1.346
                        ],
                        [
                          136.818,
                          15.364
                        ],
                        [
                          126.025,
                          6.268
                        ],
                        [
                          114.606,
                          4.155
                        ],
                        [
                          125.181,
                          11.344
                        ],
                        [
                          136.395,
                          24.888
                        ],
                        [
                          149.521,
                          35.475
                        ],
                        [
                          157.551,
                          31.679
                        ],
                        [
                          151.026,
                          37.372
                        ],
                        [
                          163.686,
                          32.949
                        ],
                        [
                          156.319,
                          37.799
                        ],
                        [
                          168.134,
                          34.004
                        ],
                        [
                          147.823,
                          46.905
                        ],
                        [
                          131.314,
                          39.715
                        ],
                        [
                          112.055,
                          20.45
                        ],
                        [
                          92.163,
                          4.994
                        ],
                        [
                          87.504,
                          5.205
                        ],
                        [
                          77.556,
                          5.84
                        ],
                        [
                          61.048,
                          39.715
                        ],
                        [
                          57.456,
                          52.591
                        ],
                        [
                          59.918,
                          71.434
                        ],
                        [
                          60.274,
                          80.152
                        ],
                        [
                          51.555,
                          96.345
                        ],
                        [
                          45.395,
                          109.017
                        ],
                        [
                          41.999,
                          117.383
                        ],
                        [
                          33.954,
                          123.102
                        ],
                        [
                          29.717,
                          126.277
                        ],
                        [
                          19.141,
                          125.849
                        ],
                        [
                          15.965,
                          122.255
                        ],
                        [
                          25.488,
                          115.484
                        ],
                        [
                          31.66,
                          113.296
                        ],
                        [
                          35.009,
                          108.828
                        ],
                        [
                          44.507,
                          84.948
                        ],
                        [
                          42.413,
                          65.678
                        ],
                        [
                          38.082,
                          43.328
                        ],
                        [
                          35.287,
                          34.529
                        ],
                        [
                          20.486,
                          49.75
                        ],
                        [
                          18.808,
                          62.602
                        ],
                        [
                          14.757,
                          70.138
                        ],
                        [
                          -20.155,
                          84.807
                        ],
                        [
                          -28.113,
                          88.716
                        ],
                        [
                          -30.21,
                          89.418
                        ],
                        [
                          -31.47,
                          90.395
                        ],
                        [
                          -32.028,
                          94.161
                        ],
                        [
                          -35.233,
                          96.674
                        ],
                        [
                          -47.105,
                          97.794
                        ],
                        [
                          -47.389,
                          94.436
                        ],
                        [
                          -42.218,
                          87.04
                        ],
                        [
                          -35.793,
                          83.69
                        ],
                        [
                          -31.049,
                          80.616
                        ],
                        [
                          -17.639,
                          73.91
                        ],
                        [
                          -5.072,
                          68.048
                        ],
                        [
                          0.658,
                          61.345
                        ],
                        [
                          2.331,
                          50.867
                        ],
                        [
                          2.327,
                          36.208
                        ],
                        [
                          -13.725,
                          41.234
                        ],
                        [
                          -31.187,
                          45.557
                        ],
                        [
                          -41.239,
                          45.981
                        ],
                        [
                          -57.863,
                          45.836
                        ],
                        [
                          -62.467,
                          52.548
                        ],
                        [
                          -68.473,
                          53.663
                        ],
                        [
                          -85.791,
                          56.734
                        ],
                        [
                          -98.923,
                          58.969
                        ],
                        [
                          -100.038,
                          63.858
                        ],
                        [
                          -87.186,
                          75.307
                        ],
                        [
                          -82.581,
                          77.405
                        ],
                        [
                          -81.187,
                          77.263
                        ],
                        [
                          -76.717,
                          71.956
                        ],
                        [
                          -64.562,
                          74.469
                        ],
                        [
                          -65.54,
                          78.94
                        ],
                        [
                          -70.012,
                          81.457
                        ],
                        [
                          -73.783,
                          83.134
                        ],
                        [
                          -77.555,
                          83.826
                        ],
                        [
                          -81.745,
                          84.807
                        ],
                        [
                          -88.443,
                          86.203
                        ],
                        [
                          -91.796,
                          82.294
                        ],
                        [
                          -105.758,
                          68.324
                        ],
                        [
                          -110.092,
                          62.464
                        ],
                        [
                          -109.531,
                          55.061
                        ],
                        [
                          -117.074,
                          63.72
                        ],
                        [
                          -122.803,
                          75.307
                        ],
                        [
                          -126.569,
                          82.294
                        ],
                        [
                          -128.523,
                          84.664
                        ],
                        [
                          -128.803,
                          87.32
                        ],
                        [
                          -126.708,
                          88.995
                        ],
                        [
                          -127.685,
                          95.426
                        ],
                        [
                          -138.024,
                          101.983
                        ],
                        [
                          -139.56,
                          97.794
                        ],
                        [
                          -139.001,
                          91.931
                        ],
                        [
                          -136.767,
                          87.181
                        ],
                        [
                          -134.252,
                          80.895
                        ],
                        [
                          -129.783,
                          70.008
                        ],
                        [
                          -121.267,
                          55.62
                        ],
                        [
                          -120.428,
                          52.684
                        ],
                        [
                          -116.933,
                          47.104
                        ],
                        [
                          -112.046,
                          42.632
                        ],
                        [
                          -96.825,
                          36.488
                        ],
                        [
                          -90.088,
                          33.043
                        ],
                        [
                          -97.645,
                          13.659
                        ],
                        [
                          -100.082,
                          -3.297
                        ],
                        [
                          -100.942,
                          -4.263
                        ],
                        [
                          -102.399,
                          -6.464
                        ],
                        [
                          -112.038,
                          -25.124
                        ],
                        [
                          -115.206,
                          -29.635
                        ],
                        [
                          -130.205,
                          -27.807
                        ],
                        [
                          -137.039,
                          -24.03
                        ],
                        [
                          -136.916,
                          -20.373
                        ],
                        [
                          -137.647,
                          -18.297
                        ],
                        [
                          -139.596,
                          -18.539
                        ],
                        [
                          -142.893,
                          -21.711
                        ],
                        [
                          -146.061,
                          -18.539
                        ],
                        [
                          -147.041,
                          -18.17
                        ],
                        [
                          -150.698,
                          -14.146
                        ],
                        [
                          -156.794,
                          -14.514
                        ],
                        [
                          -158.132,
                          -15.485
                        ],
                        [
                          -161.917,
                          -18.664
                        ],
                        [
                          -162.768,
                          -20.733
                        ],
                        [
                          -164.965,
                          -27.681
                        ],
                        [
                          -156.551,
                          -39.399
                        ],
                        [
                          -157.523,
                          -44.631
                        ],
                        [
                          -156.063,
                          -47.557
                        ],
                        [
                          -151.918,
                          -49.878
                        ],
                        [
                          -150.086,
                          -49.268
                        ],
                        [
                          -144.112,
                          -58.168
                        ],
                        [
                          -141.427,
                          -61.464
                        ],
                        [
                          -138.499,
                          -65.733
                        ],
                        [
                          -134.842,
                          -69.152
                        ],
                        [
                          -130.694,
                          -71.948
                        ],
                        [
                          -127.037,
                          -75.734
                        ],
                        [
                          -123.991,
                          -79.143
                        ],
                        [
                          -121.304,
                          -80.854
                        ],
                        [
                          -120.815,
                          -76.344
                        ],
                        [
                          -113.501,
                          -81.589
                        ],
                        [
                          -111.43,
                          -83.048
                        ],
                        [
                          -113.13,
                          -75.855
                        ],
                        [
                          -114.721,
                          -71.102
                        ],
                        [
                          -113.261,
                          -71.339
                        ],
                        [
                          -104.478,
                          -72.201
                        ],
                        [
                          -109.475,
                          -72.073
                        ],
                        [
                          -98.254,
                          -69.758
                        ],
                        [
                          -106.793,
                          -69.758
                        ],
                        [
                          -96.305,
                          -67.193
                        ],
                        [
                          -97.034,
                          -67.076
                        ],
                        [
                          -90.817,
                          -62.561
                        ],
                        [
                          -84.597,
                          -61.346
                        ],
                        [
                          -88.623,
                          -60.855
                        ],
                        [
                          -83.017,
                          -57.439
                        ],
                        [
                          -85.94,
                          -57.56
                        ],
                        [
                          -72.525,
                          -50.977
                        ],
                        [
                          -67.889,
                          -51.836
                        ],
                        [
                          -67.163,
                          -54.511
                        ],
                        [
                          -65.33,
                          -54.025
                        ],
                        [
                          -63.259,
                          -53.297
                        ],
                        [
                          -61.309,
                          -55.974
                        ],
                        [
                          -59.845,
                          -58.168
                        ],
                        [
                          -58.506,
                          -61.956
                        ],
                        [
                          -56.704,
                          -64.732
                        ],
                        [
                          -56.366,
                          -66.535
                        ],
                        [
                          -56.309,
                          -69.336
                        ],
                        [
                          -55.972,
                          -71.074
                        ],
                        [
                          -56.757,
                          -73.091
                        ],
                        [
                          -57.377,
                          -74.379
                        ],
                        [
                          -61.243,
                          -81.998
                        ],
                        [
                          -63.707,
                          -84.971
                        ],
                        [
                          -67.686,
                          -88.609
                        ],
                        [
                          -69.314,
                          -91.188
                        ],
                        [
                          -69.48,
                          -92.032
                        ],
                        [
                          -70.262,
                          -92.256
                        ],
                        [
                          -72.005,
                          -92.536
                        ],
                        [
                          -75.533,
                          -93.266
                        ],
                        [
                          -76.314,
                          -92.199
                        ],
                        [
                          -77.383,
                          -91.807
                        ],
                        [
                          -79.509,
                          -91.303
                        ],
                        [
                          -81.922,
                          -91.023
                        ],
                        [
                          -83.378,
                          -92.139
                        ],
                        [
                          -84.838,
                          -93.04
                        ],
                        [
                          -84.558,
                          -94.048
                        ],
                        [
                          -85.509,
                          -93.711
                        ],
                        [
                          -86.57,
                          -93.769
                        ],
                        [
                          -87.975,
                          -94.662
                        ],
                        [
                          -88.589,
                          -94.103
                        ],
                        [
                          -90.049,
                          -94.612
                        ],
                        [
                          -90.772,
                          -97.19
                        ],
                        [
                          -92.065,
                          -99.147
                        ],
                        [
                          -92.351,
                          -100.604
                        ],
                        [
                          -94.024,
                          -100.665
                        ],
                        [
                          -94.699,
                          -101.334
                        ],
                        [
                          -94.757,
                          -102.117
                        ],
                        [
                          -97.614,
                          -101.281
                        ],
                        [
                          -96.101,
                          -104.469
                        ],
                        [
                          -83.605,
                          -122.24
                        ],
                        [
                          -83.268,
                          -123.302
                        ],
                        [
                          -82.874,
                          -125.995
                        ],
                        [
                          -80.69,
                          -126.724
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 7",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 7,
                  "ty": "sh",
                  "ix": 8,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          -1.695,
                          0.381
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          2.157,
                          -0.454
                        ],
                        [
                          0.078,
                          -0.689
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          -116.757,
                          -30.936
                        ],
                        [
                          -119.151,
                          -32.099
                        ],
                        [
                          -124.32,
                          -30.482
                        ],
                        [
                          -125.089,
                          -29.941
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 8",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 8,
                  "ty": "sh",
                  "ix": 9,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          -0.517,
                          -0.316
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -2.304,
                          0.486
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.624,
                          -0.036
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          -0.45,
                          0.755
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.311,
                          0.411
                        ],
                        [
                          1.1,
                          0.512
                        ],
                        [
                          2.889,
                          -0.316
                        ],
                        [
                          -0.65,
                          0.042
                        ],
                        [
                          1.721,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          1.478,
                          0.207
                        ],
                        [
                          0.86,
                          -1.792
                        ],
                        [
                          -0.685,
                          -2.061
                        ],
                        [
                          0.52,
                          -0.925
                        ],
                        [
                          -0.48,
                          0.481
                        ]
                      ],
                      "v": [
                        [
                          -45.517,
                          -43.459
                        ],
                        [
                          -46.137,
                          -44.261
                        ],
                        [
                          -56.023,
                          -41.884
                        ],
                        [
                          -60.671,
                          -42.189
                        ],
                        [
                          -61.152,
                          -42.263
                        ],
                        [
                          -61.496,
                          -43.396
                        ],
                        [
                          -61.877,
                          -43.775
                        ],
                        [
                          -63.525,
                          -42.922
                        ],
                        [
                          -65.256,
                          -40.949
                        ],
                        [
                          -63.046,
                          -40.435
                        ],
                        [
                          -57.191,
                          -40.361
                        ],
                        [
                          -52.202,
                          -40.404
                        ],
                        [
                          -54.574,
                          -39.714
                        ],
                        [
                          -50.548,
                          -39.506
                        ],
                        [
                          -51.473,
                          -39.165
                        ],
                        [
                          -46.377,
                          -37.373
                        ],
                        [
                          -43.658,
                          -38.958
                        ],
                        [
                          -43.559,
                          -42.779
                        ],
                        [
                          -44.176,
                          -43.433
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 9",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 9,
                  "ty": "sh",
                  "ix": 10,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0.995,
                          -0.797
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.138,
                          0.891
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.515,
                          -0.452
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.209,
                          0.068
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          -46.858,
                          -50.18
                        ],
                        [
                          -43.59,
                          -50.013
                        ],
                        [
                          -42.522,
                          -52.484
                        ],
                        [
                          -42.491,
                          -55.727
                        ],
                        [
                          -43.728,
                          -54.214
                        ],
                        [
                          -44.483,
                          -53.28
                        ],
                        [
                          -44.726,
                          -53.043
                        ],
                        [
                          -45.449,
                          -52.594
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 10",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 10,
                  "ty": "sh",
                  "ix": 11,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0.893,
                          -0.896
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          -60.77,
                          -44.055
                        ],
                        [
                          -59.223,
                          -46.461
                        ],
                        [
                          -59.876,
                          -45.914
                        ],
                        [
                          -61.152,
                          -44.6
                        ],
                        [
                          -61.225,
                          -44.117
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 11",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 11,
                  "ty": "sh",
                  "ix": 12,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          -1.62,
                          0.894
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0.071,
                          -0.353
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          -55.642,
                          -46.703
                        ],
                        [
                          -58.949,
                          -43.743
                        ],
                        [
                          -57.056,
                          -44.117
                        ],
                        [
                          -55.921,
                          -45.676
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 12",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 12,
                  "ty": "sh",
                  "ix": 13,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0.138,
                          0.234
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          -44.212,
                          -48.8
                        ],
                        [
                          -45.619,
                          -48.8
                        ],
                        [
                          -44.246,
                          -48.459
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 13",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "mm",
                  "mm": 1,
                  "nm": "Merge Paths 1",
                  "mn": "ADBE Vector Filter - Merge",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [
                      0.952941176471,
                      0.325490196078,
                      1,
                      1
                    ],
                    "ix": 4
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 5
                  },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": {
                    "a": 0,
                    "k": [
                      168.384,
                      127.586
                    ],
                    "ix": 2
                  },
                  "a": {
                    "a": 0,
                    "k": [
                      0,
                      0
                    ],
                    "ix": 1
                  },
                  "s": {
                    "a": 0,
                    "k": [
                      100,
                      100
                    ],
                    "ix": 3
                  },
                  "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 6
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 7
                  },
                  "sk": {
                    "a": 0,
                    "k": 0,
                    "ix": 4
                  },
                  "sa": {
                    "a": 0,
                    "k": 0,
                    "ix": 5
                  },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 15,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 31.0000012626559,
          "st": -30.0000012219251,
          "bm": 0
        }
      ]
    }
  ],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 0,
      "nm": "Animation horse",
      "refId": "comp_0",
      "sr": 1,
      "ks": {
        "o": {
          "a": 0,
          "k": 100,
          "ix": 11
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 10
        },
        "p": {
          "a": 0,
          "k": [
            540,
            540,
            0
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [
            960,
            540,
            0
          ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 0,
          "k": [
            69.46,
            69.46,
            100
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "tm": {
        "a": 1,
        "k": [
          {
            "i": {
              "x": [
                0.833
              ],
              "y": [
                0.833
              ]
            },
            "o": {
              "x": [
                0.167
              ],
              "y": [
                0.167
              ]
            },
            "t": 0,
            "s": [
              0
            ]
          },
          {
            "t": 15.0000006109625,
            "s": [
              2.97
            ]
          }
        ],
        "ix": 2,
        "x": "var $bm_rt;\n$bm_rt = loopOut('cycle', 0);"
      },
      "w": 1920,
      "h": 1080,
      "ip": 0,
      "op": 90.0000036657751,
      "st": 0,
      "bm": 0
    }
  ],
  "markers": []
}